import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Popover, OverlayTrigger } from "react-bootstrap";
import Moment from "react-moment";
import InternalReviewPopup from "./InternalReviewPopup";
import DefaultDocumentsModal from "./DefaultDocumentsModal";
import CandidateReqDoc from "../OMCRegistry/CandidateReqDoc";
import {
  getCurrentClientDeatils,
  getCurrentUser,
  loadClientDetails,
} from "../../app/store/auth";
import { useDispatch, useSelector } from "react-redux";
import {
  addComment,
  getCommentAddedStatus,
  getCommentUpdatedStatus,
  loadAppComments,
  updateComment,
} from "../../app/store/comments";
import {
  deleteDocument,
  deleteReqDocument,
  getDocumentDeleteStatus,
  getDocumentPurgeStatus,
  getDocumentRollbackStatus,
  getDocuments,
  getDocumentsLoading,
  getDocumentsSendStatus,
  getEsignDocuments,
  getReqDocDeleteStatus,
  getReqDocSendStatus,
  getReqDocuments,
  getWfPhasesDoc,
  getesignDocumentsSendStatus,
  loadDocuments,
  loadEsignDocuments,
  loadReqDocuments,
  loadSignedDocument,
  loadWfPhasesDocs,
  purgeDocument,
  rollbackDocument,
  sendDocuments,
  sendReqDocuments,
  signedDocumentReceived,
  updateReceivedDocStatus,
  getEsignPrepToken,
  getEsignUploadStatus,
  uploadToEsign,
  esignUploadReset,
  loadDocEsignLinks,
  getDocEsignLinks,
} from "../../app/store/documents";
import { getAlert, getConfirmAlert, getSigningModeChoice } from "../../services/appAlerts";
import useDocDownload from "../../app/hooks/useDocDownload";
import UploadOther from "../../app/components/Document/UploadOther";
import GenerateContract from "../../app/components/Contract/GenerateContract";
import defaultDocsConfig from "../../services/defaultDocumentsConfig.json";
import {
  addDefaultDocumentsConfig,
  loadAllDataTypeMappings,
  loadDefaultDocumentsConfig,
  getDataTypeMappings
} from "../../app/store/dataTypes";
import { getDdrmsRepositoryDocuments, loadDdrmsRepositoryDocs } from "../../app/store/ddrmsDocument";
import { Modal } from "react-bootstrap";
import {
  getSubsCurrentWfTask,
  loadSubcontractorWfTask,
  subsCurrentWfTaskReceived,
} from "../../app/store/subcontractor";
import {
  getRecCurrentWfTask,
  loadRecruiterWfTask,
  recCurrentWfTaskReceived,
} from "../../app/store/recruiter";
import moment from "moment";
import { candidateCurrentWfTaskReceived, getCandidateCurrentWfTask, loadCandidateWfTask } from "../../app/store/candidate";
import PurchaseOrderPopup from "../../ReviewTools/PurchaseOrderPopup";

const CustomTabs = ({ defaultActiveKey, children }) => {
  const [activeKey, setActiveKey] = useState(defaultActiveKey);

  useEffect(() => {
    setActiveKey(defaultActiveKey);
  }, [defaultActiveKey]);

  const tabChildren = React.Children.toArray(children).filter(
    (child) => child && child.type === CustomTab
  );

  return (
    <React.Fragment>
      <div className="custom-tabs-container">
        <div className="custom-tabs-list">
          {tabChildren.map((child) => {
            const { eventKey, title } = child.props;
            const isActive = activeKey === eventKey;
            return (
              <button
                key={eventKey}
                className={`custom-tab-item ${isActive ? "active" : ""}`}
                onClick={() => setActiveKey(eventKey)}
                type="button"
              >
                {title}
              </button>
            );
          })}
        </div>
      </div>
      <div className="custom-tabs-content">
        {tabChildren.map((child) => {
          const { eventKey } = child.props;
          const isActive = activeKey === eventKey;
          return (
            <div
              key={eventKey}
              className="pdm-tab-pane"
              style={{ display: isActive ? "block" : "none" }}
            >
              {child.props.children}
            </div>
          );
        })}
      </div>
    </React.Fragment>
  );
};

const CustomTab = ({ children }) => {
  return children;
};

const getDynamicTabTitle = (uploadType) => {
  if (!uploadType) return "Contract Documents";
  const typeLower = uploadType.toLowerCase();
  if (typeLower === "agency") return "Agency Documents";
  if (typeLower === "subcontractor") return "Subcontractor Documents";
  if (typeLower === "recruiter") return "Recruiter Documents";
  if (typeLower === "msp") return "MSP Documents";
  return "Contract Documents";
};

const DOC_ICON_BY_EXTENSION = {
  pdf: "fa-file-pdf-o",
  doc: "fa-file-word-o", docx: "fa-file-word-o", rtf: "fa-file-word-o", odt: "fa-file-word-o",
  xls: "fa-file-excel-o", xlsx: "fa-file-excel-o", csv: "fa-file-excel-o", ods: "fa-file-excel-o",
  ppt: "fa-file-powerpoint-o", pptx: "fa-file-powerpoint-o", odp: "fa-file-powerpoint-o",
  png: "fa-file-image-o", jpg: "fa-file-image-o", jpeg: "fa-file-image-o", gif: "fa-file-image-o",
  bmp: "fa-file-image-o", webp: "fa-file-image-o", svg: "fa-file-image-o",
  tif: "fa-file-image-o", tiff: "fa-file-image-o", heic: "fa-file-image-o",
  zip: "fa-file-archive-o", rar: "fa-file-archive-o", "7z": "fa-file-archive-o",
  tar: "fa-file-archive-o", gz: "fa-file-archive-o",
  txt: "fa-file-text-o", log: "fa-file-text-o", md: "fa-file-text-o",
  mp3: "fa-file-audio-o", wav: "fa-file-audio-o", m4a: "fa-file-audio-o",
  mp4: "fa-file-video-o", mov: "fa-file-video-o", avi: "fa-file-video-o", mkv: "fa-file-video-o",
  html: "fa-file-code-o", xml: "fa-file-code-o", json: "fa-file-code-o"
};

// Prefers the filename extension; falls back to the stored MIME type when the
// name carries no usable extension.
const getDocumentIcon = (doc) => {
  const name = String(doc?.docName || "").trim().toLowerCase();
  const ext = name.includes(".") ? name.slice(name.lastIndexOf(".") + 1) : "";
  if (DOC_ICON_BY_EXTENSION[ext]) return DOC_ICON_BY_EXTENSION[ext];

  const mime = String(doc?.docType || "").trim().toLowerCase();
  if (mime.startsWith("image/")) return "fa-file-image-o";
  if (mime.startsWith("audio/")) return "fa-file-audio-o";
  if (mime.startsWith("video/")) return "fa-file-video-o";
  if (mime.startsWith("text/")) return "fa-file-text-o";
  if (mime === "application/pdf") return "fa-file-pdf-o";
  if (mime.includes("word")) return "fa-file-word-o";
  if (mime.includes("sheet") || mime.includes("excel")) return "fa-file-excel-o";
  if (mime.includes("presentation") || mime.includes("powerpoint")) return "fa-file-powerpoint-o";
  if (mime.includes("zip") || mime.includes("compressed")) return "fa-file-archive-o";

  return "fa-file-o";
};

const getFallbackDefaultDocuments = (flowType) => {
  const configKeyByFlow = {
    C2C: "defaultC2CDocuments",
    W2: "defaultW2Documents",
    "1099": "default1099Documents",
    Sub: "defaultSubDocuments",
    SubCan: "defaultSubCanDocuments",
    Rec: "defaultRecDocuments"
  };
  const documents = defaultDocsConfig[configKeyByFlow[flowType]] || [];
  return documents.map((doc) => ({ ...doc }));
};

const getCandidatePurchaseOrderDocuments = (documents, candidate, flowType) => {
  const isPurchaseOrder = (doc) =>
    String(doc?.name || "").trim().toLowerCase().startsWith("purchase order");
  const purchaseOrderIndex = documents.findIndex(isPurchaseOrder);
  if (purchaseOrderIndex < 0 && flowType !== "SubCan") return documents;

  const template = purchaseOrderIndex >= 0
    ? documents[purchaseOrderIndex]
    : { name: "Purchase Order (also Revised Purchase Order)", action: "generate" };
  const insertionIndex = purchaseOrderIndex >= 0 ? purchaseOrderIndex : documents.length;
  const purchaseOrderDocuments = [];
  if (candidate?.subcontractor?.fuid > 0) {
    purchaseOrderDocuments.push({
      ...template,
      name: "Purchase Order - Subcontractor",
      action: "generate",
      purchaseOrderType: "subcontractor"
    });
  }
  if (candidate?.recruiter?.fuid > 0) {
    purchaseOrderDocuments.push({
      ...template,
      name: "Purchase Order - Recruiter",
      action: "generate",
      purchaseOrderType: "recruiter"
    });
  }

  return [
    ...documents.slice(0, insertionIndex).filter((doc) => !isPurchaseOrder(doc)),
    ...purchaseOrderDocuments,
    ...documents.slice(purchaseOrderIndex >= 0 ? purchaseOrderIndex + 1 : insertionIndex)
      .filter((doc) => !isPurchaseOrder(doc))
  ];
};

const getDocTrackId = (doc, idx) => {
  if (doc?._id) return doc._id;
  if (doc?.id) return String(doc.id);
  const base = doc?.name ? doc.name.trim().toLowerCase() : `item_${idx}`;
  const suffix = doc?.reqDocId ? `_req_${doc.reqDocId}` : (doc?.ddrmsDocId ? `_ddrms_${doc.ddrmsDocId}` : `_${idx}`);
  return `cfg_${base}${suffix}`;
};

const ensureDocKeys = (docs) => {
  if (!Array.isArray(docs)) return [];
  return docs.map((doc, idx) => ({
    ...doc,
    _id: getDocTrackId(doc, idx)
  }));
};

const getDefaultDocumentFlowType = (applicationType, viewType, uploadType) => {
  // On Candidate page/list, default documents are shown for Candidate, Subcontractor, and Recruiter,
  // and NOT for Agency/Client or MSP.
  if (viewType === "candidateList") {
    const norm = String(uploadType || "").trim().toLowerCase();
    if (norm === "subcontractor" || norm === "sub") {
      return "Sub";
    }
    if (norm === "recruiter" || norm === "rec") {
      return "Rec";
    }
    if (norm !== "candidate") {
      return null;
    }
  }

  const flowByApplicationType = {
    "C2C Candidate Onboarding": "C2C",
    "W2 Candidate Onboarding": "W2",
    "1099 Candidate Onboarding": "1099",
    "Subcontractor Application": "Sub",
    "Recruiter Application": "Rec",
    "Candidate Application": "C2C"
  };
  if (applicationType && flowByApplicationType[applicationType]) {
    return flowByApplicationType[applicationType];
  }

  const appTypeStr = String(applicationType || "").trim().toLowerCase();
  if (appTypeStr.includes("w2") || appTypeStr.includes("w-2")) return "W2";
  if (appTypeStr.includes("1099")) return "1099";
  if (appTypeStr.includes("subcontractor")) return "Sub";
  if (appTypeStr.includes("recruiter")) return "Rec";
  if (appTypeStr.includes("c2c") || appTypeStr.includes("candidate")) return "C2C";

  const normUploadType = String(uploadType || "").trim().toLowerCase();
  if (normUploadType.includes("subcontractor") || normUploadType === "sub") return "Sub";
  if (normUploadType.includes("recruiter") || normUploadType === "rec") return "Rec";
  if (normUploadType.includes("candidate") || normUploadType === "c2c" || viewType === "candidateList") return "C2C";
  return "C2C";
};

const Document = (props) => {
  const {
    workflowTask,
    uploadType,
    app,
    item: rawApplicantObj,
    viewType,
    pageModule,
    handleCloseDocumentView,
    onBack,
    type,
    prevItem,
    embedded = false
  } = props;

  const applicantObj = rawApplicantObj ? { ...rawApplicantObj } : rawApplicantObj;
  if (applicantObj && !applicantObj.id) {
    if (applicantObj.fuid) applicantObj.id = applicantObj.fuid;
    else if (applicantObj.performerid) applicantObj.id = applicantObj.performerid;
  }

  const [appDocuments, setAppDocuments] = useState([]);
  const [reqDocuments, setReqDocuments] = useState([]);
  const [sendType, setSendType] = useState("");
  const [docShowHide, setDocShowHide] = useState(false);
  const [showHide, setShowHide] = useState(false);
  const [otherDocShowHide, setOtherDocShowHide] = useState(false);
  const [contractShowHide, setContractShowHide] = useState(false);
  const [selectedObj, setSelectedObj] = useState(null);
  const [copyItem, setCopyItem] = useState("");
  const [esignDocuments, setEsignDocuments] = useState([]);
  const [selectedSignedDoc, setSelectedSignedDoc] = useState(null);
  const [signLoading, setSignLoading] = useState(false);
  const [onReqDocs, setOnReqDocs] = useState([]);
  const [esignUploadLoading, setEsignUploadLoading] = useState(false);
  const [loadingDocId, setLoadingDocId] = useState(null);
  const [esignSignLinkLoadingId, setEsignSignLinkLoadingId] = useState(null);
  const [clientDetails, setClientDetails] = useState(null);
  const [defaultActiveKey, setDefaultActiveKey] = useState(2);
  const [partnerCurrentWfTask, setPartnerCurrentWfTask] = useState(null);
  const [activeNotesDocId, setActiveNotesDocId] = useState(null);
  const [partnerAppData, setPartnerAppData] = useState(null);
  const [achCheckCount, setAchCheckCount] = useState(0);
  const [uploadDocType, setUploadDocType] = useState("");
  const [wfTask, setWfTask] = useState(null);
  const [wfTaskReqCount, setWfTaskReqCount] = useState(0);
  const [showDefaultDocsModal, setShowDefaultDocsModal] = useState(false);
  const [defaultC2CDocuments, setDefaultC2CDocuments] = useState([]);
  const [activeFlowType, setActiveFlowType] = useState("");
  const [selectedReqDoc, setSelectedReqDoc] = useState(null);
  const [selectedReqDocMapping, setSelectedReqDocMapping] = useState(null);
  const [hasFetchedForCiid, setHasFetchedForCiid] = useState(false);
  const [viewOverride, setViewOverride] = useState(null); // 'default' | 'current' | null

  const appDocumentSelector = useSelector(getDocuments);
  const isDocumentsLoading = useSelector(getDocumentsLoading);
  const updateCommentsSelector = useSelector(getCommentUpdatedStatus);
  const documentSendStatusSelector = useSelector(getDocumentsSendStatus);
  const esignDocumentSendStatusSelector = useSelector(
    getesignDocumentsSendStatus
  );
  const documentDeleteStatusSelector = useSelector(getDocumentDeleteStatus);
  const documentPurgeStatusSelector = useSelector(getDocumentPurgeStatus);
  const documentRollbackStatusSelector = useSelector(getDocumentRollbackStatus);
  const reqDocumentsSelector = useSelector(getReqDocuments);
  const commentAddedStatusSelector = useSelector(getCommentAddedStatus);
  const reqDocSendStatusSelector = useSelector(getReqDocSendStatus);
  const reqDocDeleteStatusSelector = useSelector(getReqDocDeleteStatus);
  const esignDocumentsSelector = useSelector(getEsignDocuments);
  const getWfPhasesDocSelector = useSelector(getWfPhasesDoc);
  const currentClientDeatilsSelector = useSelector(getCurrentClientDeatils);
  const subsCurrentWfTaskSelector = useSelector(getSubsCurrentWfTask);
  const recCurrentWfTaskSelector = useSelector(getRecCurrentWfTask);
  const candidateCurrentWfTaskSelector = useSelector(getCandidateCurrentWfTask);
  const esignPrepTokenSelector = useSelector(getEsignPrepToken);
  const esignUploadStatusSelector = useSelector(getEsignUploadStatus);
  const docEsignLinks = useSelector(getDocEsignLinks);
  const dataTypeMappingsSelector = useSelector(getDataTypeMappings);
  const ddrmsDocsSelector = useSelector(getDdrmsRepositoryDocuments);

  const [handleDownloadFile] = useDocDownload();

  const dispatch = useDispatch();
  const currentUser = getCurrentUser();

  const getEsignBaseUrl = () =>
    window.location.hostname === "localhost"
      ? "http://localhost:5173"
      : (process?.env?.REACT_APP_ESIGN_BASEURL || "http://localhost:5173");

  const getEsignApiBaseUrl = () =>
    process?.env?.REACT_APP_ESIGN_API_BASEURL ||
    process?.env?.REACT_APP_ESIGN_API_URL ||
    (window.location.hostname === "localhost" ? "http://localhost:5005" : getEsignBaseUrl());

  const getWorkbenchApiBaseUrl = () => (process?.env?.REACT_APP_API_BASEURL || "").replace(/\/$/, "");

  const isESignDocumentSigned = (status) => {
    const normalized = String(status || "").replace(/\s+/g, "").toLowerCase();
    return normalized === "1" || normalized === "signed" || normalized === "completed";
  };

  useEffect(() => {
    if (esignUploadStatusSelector === "success" && esignPrepTokenSelector) {
      setEsignUploadLoading(false);
      setLoadingDocId(null);
      const esignBaseUrl = getEsignBaseUrl();
      const prepUrl = `${esignBaseUrl}/prepare/${esignPrepTokenSelector}`;
      window.open(prepUrl, "_blank");

      dispatch(esignUploadReset());

      if (wfTask?.ciid) {
        dispatch(loadDocuments(wfTask.ciid));
      } else if (partnerCurrentWfTask?.ciid) {
        dispatch(loadDocuments(partnerCurrentWfTask.ciid));
      }
    } else if (esignUploadStatusSelector === "failed") {
      setEsignUploadLoading(false);
      setLoadingDocId(null);
      getAlert("", "Failed to upload document to eSign API.", "error");
      dispatch(esignUploadReset());
    }
  }, [esignUploadStatusSelector, esignPrepTokenSelector]);

  useEffect(() => {
    if (!currentClientDeatilsSelector) dispatch(loadClientDetails());
    dispatch(loadAllDataTypeMappings());
  }, []);

  useEffect(() => {
    const isCandidateListPartner =
      viewType === "candidateList" &&
      (uploadType === "Subcontractor" || uploadType === "Recruiter");

    if (workflowTask?.ciid > 0 && !isCandidateListPartner) {
      dispatch(loadDocuments(workflowTask.ciid));
      dispatch(loadReqDocuments(workflowTask.ciid));
      dispatch(loadDdrmsRepositoryDocs(workflowTask.ciid));
      setPartnerCurrentWfTask(workflowTask);
      setWfTask(workflowTask);
      if (applicantObj?.id) dispatch(loadEsignDocuments(applicantObj?.id, currentUser?.id));
      setWfTaskReqCount(0);
    }
    else if (uploadType === "Subcontractor") {
      setPartnerCurrentWfTask(null);
      setWfTask(null);
      let partnerUsrId = applicantObj?.id;
      if (viewType === "candidateList")
        partnerUsrId = applicantObj?.subcontractor?.parentid;
      if (partnerUsrId > 0) {
        dispatch(subsCurrentWfTaskReceived(null));
        dispatch(loadSubcontractorWfTask(partnerUsrId));
        setWfTaskReqCount(wfTaskReqCount + 1);
      }
    }
    else if (uploadType === "Recruiter") {
      setPartnerCurrentWfTask(null);
      setWfTask(null);
      let partnerUsrId = applicantObj?.id;
      if (viewType === "candidateList")
        partnerUsrId = applicantObj?.recruiter?.parentid;
      if (partnerUsrId > 0) {
        dispatch(recCurrentWfTaskReceived(null));
        dispatch(loadRecruiterWfTask(partnerUsrId));
        setWfTaskReqCount(wfTaskReqCount + 1);
      }
    }
    else if (applicantObj?.id && uploadType === "Candidate") {
      dispatch(loadCandidateWfTask(applicantObj?.id));
      setWfTaskReqCount(wfTaskReqCount + 1);
    }
    loadReqDocTypes();
  }, [workflowTask, uploadType]);

  // Clean up stale partner tasks when switching uploadType or unmounting
  useEffect(() => {
    return () => {
      dispatch(subsCurrentWfTaskReceived(null));
      dispatch(recCurrentWfTaskReceived(null));
    };
  }, [uploadType]);

  useEffect(() => {
    if (uploadType === "Subcontractor" && subsCurrentWfTaskSelector && subsCurrentWfTaskSelector !== 0) {
      dispatch(loadDocuments(subsCurrentWfTaskSelector.ciid));
      dispatch(loadReqDocuments(subsCurrentWfTaskSelector.ciid));
      dispatch(loadDdrmsRepositoryDocs(subsCurrentWfTaskSelector.ciid));
      if (applicantObj?.subcontractor?.parentid)
        dispatch(loadEsignDocuments(applicantObj?.subcontractor?.parentid, currentUser?.id));

      setPartnerCurrentWfTask(subsCurrentWfTaskSelector);
      setWfTask(subsCurrentWfTaskSelector);
      setPartnerAppData(subsCurrentWfTaskSelector.appData);
      setAchCheckCount(1);
      setWfTaskReqCount(0);
    }
    else if (uploadType === "Subcontractor" && subsCurrentWfTaskSelector === 0 && !workflowTask && wfTaskReqCount <= 5) {
      let partnerUsrId = applicantObj?.id;
      if (viewType === "candidateList")
        partnerUsrId = applicantObj?.subcontractor?.parentid;
      if (partnerUsrId > 0) {
        setWfTaskReqCount(wfTaskReqCount + 1);
        dispatch(subsCurrentWfTaskReceived(null));
        dispatch(loadSubcontractorWfTask(partnerUsrId));
      }
    }
  }, [subsCurrentWfTaskSelector, uploadType]);

  useEffect(() => {
    if (uploadType === "Recruiter" && recCurrentWfTaskSelector && recCurrentWfTaskSelector !== 0) {
      dispatch(loadDocuments(recCurrentWfTaskSelector.ciid));
      dispatch(loadReqDocuments(recCurrentWfTaskSelector.ciid));
      dispatch(loadDdrmsRepositoryDocs(recCurrentWfTaskSelector.ciid));
      if (applicantObj?.recruiter?.parentid)
        dispatch(loadEsignDocuments(applicantObj?.recruiter?.parentid, currentUser?.id));

      setWfTask(recCurrentWfTaskSelector);
      setPartnerCurrentWfTask(recCurrentWfTaskSelector);
      setPartnerAppData(recCurrentWfTaskSelector.appData);
      setAchCheckCount(1);
      setWfTaskReqCount(0);
    } else if (uploadType === "Recruiter" && recCurrentWfTaskSelector === 0 && !workflowTask && wfTaskReqCount <= 5) {
      let partnerUsrId = applicantObj?.id;
      if (viewType === "candidateList")
        partnerUsrId = applicantObj?.recruiter?.parentid;
      if (partnerUsrId > 0) {
        setWfTaskReqCount(wfTaskReqCount + 1);
        dispatch(recCurrentWfTaskReceived(null));
        dispatch(loadRecruiterWfTask(partnerUsrId));
      }
    }
  }, [recCurrentWfTaskSelector, uploadType]);

  useEffect(() => {
    if (uploadType === "Candidate" && candidateCurrentWfTaskSelector && candidateCurrentWfTaskSelector !== 0) {
      dispatch(loadDocuments(candidateCurrentWfTaskSelector.ciid));
      dispatch(loadReqDocuments(candidateCurrentWfTaskSelector.ciid));
      dispatch(loadDdrmsRepositoryDocs(candidateCurrentWfTaskSelector.ciid));

      if (applicantObj?.id)
        dispatch(loadEsignDocuments(applicantObj?.id, currentUser?.id));

      setWfTask(candidateCurrentWfTaskSelector);
      setPartnerCurrentWfTask(candidateCurrentWfTaskSelector);
      setWfTaskReqCount(0);
    } else if (uploadType === "Candidate" && candidateCurrentWfTaskSelector === 0 && !workflowTask && wfTaskReqCount <= 5) {
      setWfTaskReqCount(wfTaskReqCount + 1);
      dispatch(candidateCurrentWfTaskReceived(null));
      dispatch(loadCandidateWfTask(applicantObj?.id));
    }
  }, [candidateCurrentWfTaskSelector, uploadType]);

  useEffect(() => {
    setHasFetchedForCiid(false);
  }, [wfTask?.ciid, workflowTask?.ciid]);

  useEffect(() => {
    if (!isDocumentsLoading && (wfTask?.ciid || workflowTask?.ciid)) {
      setHasFetchedForCiid(true);
    }
  }, [isDocumentsLoading, wfTask?.ciid, workflowTask?.ciid, appDocumentSelector]);

  const fetchDefaultDocumentsForFlow = async (flowType) => {
    if (!flowType) return;
    if (flowType !== activeFlowType) setActiveFlowType(flowType);

    let documentsToLoad = getFallbackDefaultDocuments(flowType);
    try {
      const configRow = await dispatch(loadDefaultDocumentsConfig(flowType));
      const mappingJson = configRow?.mappingJson ?? configRow?.MappingJson;

      if (mappingJson) {
        const parsed = JSON.parse(mappingJson);
        if (Array.isArray(parsed) && parsed.length > 0) {
          documentsToLoad = parsed;
        }
      }
    } catch (e) {
      console.error("Error loading default documents config from API; using bundled fallback", e);
    }

    setDefaultC2CDocuments(
      ensureDocKeys(getCandidatePurchaseOrderDocuments(documentsToLoad, applicantObj, flowType))
    );
    return documentsToLoad;
  };

  useEffect(() => {
    let isCancelled = false;
    const flowType =
      getDefaultDocumentFlowType(app?.applicationType, viewType, uploadType);

    if (!flowType) {
      setActiveFlowType("");
      setDefaultC2CDocuments([]);
      return;
    }
    if (flowType !== activeFlowType) setActiveFlowType(flowType);

    // 1. Initial immediate populate from fallback so UI is ready without blank delay
    setDefaultC2CDocuments(
      ensureDocKeys(
        getCandidatePurchaseOrderDocuments(
          getFallbackDefaultDocuments(flowType),
          applicantObj,
          flowType
        )
      )
    );

    // 2. Fetch live config from: Review/GetDefaultDocumentsConfig/{flowType}
    // e.g. /api/Review/GetDefaultDocumentsConfig/Rec, /api/Review/GetDefaultDocumentsConfig/Sub, etc.
    const loadConfig = async () => {
      try {
        const configRow = await dispatch(loadDefaultDocumentsConfig(flowType));
        const mappingJson = configRow?.mappingJson ?? configRow?.MappingJson;

        if (mappingJson && !isCancelled) {
          const parsed = JSON.parse(mappingJson);
          if (Array.isArray(parsed)) {
            setDefaultC2CDocuments(
              ensureDocKeys(
                getCandidatePurchaseOrderDocuments(parsed, applicantObj, flowType)
              )
            );
          }
        }
      } catch (e) {
        console.error("Error loading default documents config from API; using fallback", e);
      }
    };

    loadConfig();

    return () => {
      isCancelled = true;
    };
  }, [
    app?.applicationType,
    uploadType,
    viewType,
    applicantObj?.id,
    applicantObj?.subcontractor?.fuid,
    applicantObj?.subcontractor?.parentid,
    applicantObj?.recruiter?.fuid,
    applicantObj?.recruiter?.parentid
  ]);

  const handleLoadDefaultC2CDocuments = async () => {
    const flowType =
      getDefaultDocumentFlowType(app?.applicationType, viewType, uploadType);
    if (!flowType) return;
    await fetchDefaultDocumentsForFlow(flowType);
    setShowDefaultDocsModal(true);
  };

  // Mirrors the applicantId resolution in UploadOther: on the candidate list a
  // partner's required documents belong to the partner contact, not the candidate.
  const getReqDocPerformerId = (task) => {
    let resolved = task?.applicantId;
    if (viewType === "candidateList") {
      if (uploadType === "Recruiter" && applicantObj?.recruiter?.parentid)
        resolved = applicantObj.recruiter.parentid;
      else if (uploadType === "Subcontractor" && applicantObj?.subcontractor?.parentid)
        resolved = applicantObj.subcontractor.parentid;
      else if (uploadType === "Candidate" && applicantObj?.id)
        resolved = applicantObj.id;
    } else if (applicantObj?.id) {
      resolved = applicantObj.id;
    }
    return resolved ? parseInt(resolved) : null;
  };

  // Saves the default-documents configuration only. Required documents reach the
  // checklist through the per-row upload/generate actions, not from here.
  const handleSaveAndLoadDefaultDocs = (tempDocs) => {
    const flowType = getDefaultDocumentFlowType(app?.applicationType, viewType, uploadType);
    if (!flowType) return;

    const task = ((uploadType === "Subcontractor" || uploadType === "Recruiter" || uploadType === "agency" ||
      uploadType === "msp") && viewType !== "candidateList") || (uploadType === "Candidate" && viewType === "candidateList") ? wfTask : partnerCurrentWfTask;

    if (task && task.ciid) {
      // 1. Identify which documents were in the pending subset shown in the checklist
      const pendingIds = new Set((pendingDefaultDocuments || []).map((d) => d._id).filter(Boolean));

      // 2. Preserve any already-uploaded documents that were excluded from the pending view
      const nonPendingUploadedDocs = (defaultC2CDocuments || []).filter(
        (d) => d._id && !pendingIds.has(d._id)
      );

      // 3. The new master config list is nonPendingUploadedDocs + tempDocs (the edited/deleted/added pending docs)
      const finalDocs = pendingIds.size > 0
        ? [...nonPendingUploadedDocs, ...(tempDocs || [])]
        : (tempDocs || []);

      // 1. Save configuration in database (tblDataTypeMapping).
      // The endpoint upserts on performerType, so no row id is sent.
      const configProfile = {
        name: `${flowType} Default Documents Config`,
        type: "Document",
        notes: "Default documents configuration setting",
        mappingJson: JSON.stringify(finalDocs),
        addedBy: currentUser?.id ? parseInt(currentUser.id) : 0,
        performerId: applicantObj?.id ? parseInt(applicantObj.id) : 0,
        performerType: flowType
      };

      dispatch(addDefaultDocumentsConfig(configProfile));
      getAlert("", "Default Documents config saved successfully", "success");

      setDefaultC2CDocuments(
        ensureDocKeys(getCandidatePurchaseOrderDocuments(finalDocs, applicantObj, flowType))
      );

      // 2. Reload required documents & configurations
      setTimeout(() => {
        dispatch(loadReqDocuments(task.ciid));
        dispatch(loadAllDataTypeMappings());
        dispatch(loadDefaultDocumentsConfig(flowType));
      }, 1500);

      //setShowDefaultDocsModal(false);
    }
  };

  const loadReqDocTypes = () => {
    if (viewType === "candidateList") {
      if (uploadType === "Subcontractor") {
        dispatch(loadWfPhasesDocs("Candidate Required Doc From Subcontractor"));
      } else if (app?.applicationType === "C2C Candidate Onboarding") {
        dispatch(loadWfPhasesDocs("C2C Candidates Required Docs"));
      } else if (app?.applicationType === "W2 Candidate Onboarding") {
        dispatch(loadWfPhasesDocs("W2 Candidates Required Docs"));
      } else if (app?.applicationType === "1099 Candidate Onboarding") {
        dispatch(loadWfPhasesDocs("1099 Candidates Required Docs"));
      }
    } else {
      if (app?.applicationType === "Subcontractor Application") {
        dispatch(loadWfPhasesDocs("Subcontractors Required Docs"));
      } else if (app?.applicationType === "Recruiter Application") {
        dispatch(loadWfPhasesDocs("Recruiters Required Docs"));
      }
    }
  };

  useEffect(() => {
    setOnReqDocs(getWfPhasesDocSelector);
  }, [getWfPhasesDocSelector]);

  useEffect(() => {
    const rawDocs =
      appDocumentSelector && appDocumentSelector.length > 0
        ? appDocumentSelector
        : (props.documents || []);

    if (rawDocs.length > 0) {
      let filterDocs = rawDocs.filter((x) => {
        const uploadType = (x.uploadType || "").toLowerCase();
        const updType = (x.updType || "").toLowerCase();

        const isAch =
          uploadType.startsWith("ach_") ||
          updType.startsWith("ach_") ||
          /ach_\d+/i.test(uploadType) ||
          /ach_\d+/i.test(updType);

        const isInsurance =
          uploadType.startsWith("insurance_") ||
          updType.startsWith("insurance_");

        return x.uploadType !== "req" && !isInsurance && !isAch;
      });
      setAppDocuments(filterDocs);
    } else {
      setAppDocuments([]);
    }
  }, [appDocumentSelector, props.documents]);

  useEffect(() => {
    setLoadingDocId(null);
  }, [appDocuments]);

  useEffect(() => {
    if (documentSendStatusSelector && wfTask?.ciid) {
      getAlert("", "Document Sent Successfully", "success");
      setLoadingDocId(null);
      dispatch(loadDocuments(wfTask.ciid));
      dispatch(loadReqDocuments(wfTask.ciid));
    }
  }, [documentSendStatusSelector]);

  useEffect(() => {
    if (esignDocumentSendStatusSelector && wfTask?.ciid) {
      getAlert("", "Document Sent Successfully", "success");
      setLoadingDocId(null);
      dispatch(loadDocuments(wfTask.ciid));
    }
  }, [esignDocumentSendStatusSelector]);

  useEffect(() => {
    setEsignDocuments(esignDocumentsSelector);
  }, [esignDocumentsSelector]);

  useEffect(() => {
    setClientDetails(currentClientDeatilsSelector);
  }, [currentClientDeatilsSelector]);

  useEffect(() => {
    if (updateCommentsSelector && wfTask?.ciid) {
      dispatch(loadAppComments("document", wfTask.ciid));
    }
  }, [updateCommentsSelector]);

  useEffect(() => {
    if (reqDocumentsSelector) setReqDocuments(reqDocumentsSelector);
    else setReqDocuments([]);
  }, [reqDocumentsSelector]);

  // Fetch a document's eSign links lazily (when its dropdown is opened) instead of
  // eagerly for every document on load. The old effect fired one slow GetDocumentESignLinks
  // request per document, flooding the network on mount. Every consumer already falls back
  // to env-derived URLs, so links are only needed on demand.
  const ensureDocEsignLinks = useCallback((docId) => {
    if (docId && !docEsignLinks[docId]) {
      dispatch(loadDocEsignLinks(docId));
    }
  }, [docEsignLinks, dispatch]);

  const handleModalShowHide = (item) => {
    setShowHide(!showHide);
    setSelectedObj(item);
  };

  const handleSubmit = async ({ comments }) => {
    const updatedWfTask = { ...wfTask };
    updatedWfTask.performerId = currentUser.id;
    const frmData = new FormData();
    frmData.append("comment", comments);
    frmData.append("type", "document");
    frmData.append("workflowTask", JSON.stringify(updatedWfTask));
    dispatch(addComment(frmData));
    setShowHide(false);
  };

  useEffect(() => {
    if (commentAddedStatusSelector && wfTask?.ciid) {
      dispatch(loadAppComments("document", wfTask.ciid));
    }
  }, [commentAddedStatusSelector]);

  const handleEditComment = async (item) => {
    dispatch(updateComment(item));
    setShowHide(false);
  };

  const handleDocShowHide = (type, dType) => {
    if (type === "save") {
      setDocShowHide(false);
      setSendType("");
      setUploadDocType("");
      if (wfTask?.ciid && viewType !== "candidateList")
        dispatch(loadDocuments(wfTask.ciid));
      else if (partnerCurrentWfTask?.ciid)
        dispatch(loadDocuments(partnerCurrentWfTask?.ciid));
    } else {
      setDocShowHide(!docShowHide);
      setSendType(type);
      if (dType) setUploadDocType(dType);
    }
  };

  const handleSendDoc = async (id) => {
    const docIds = [id];
    const frm = new FormData();
    frm.append("ids", docIds);
    frm.append("userId", currentUser.id);
    frm.append("ciid", wfTask?.ciid);
    const result = await getConfirmAlert(
      "Warning",
      "Are you sure you want to send this Document?",
      "warning"
    );
    if (result.isConfirmed) {
      setLoadingDocId(id);
      dispatch(sendDocuments(frm));
    }
  };

  const handleSendThroughEsign = async (item) => {
    const signingMode = await getSigningModeChoice({
      message: "Choose how the signers should sign this document.",
    });

    if (!signingMode) return;

    setEsignUploadLoading(true);
    setLoadingDocId(item.docId);
    const frm = new FormData();
    frm.append("docId", item.docId);
    frm.append("ciid", ((uploadType === "Subcontractor" || uploadType === "Recruiter" || uploadType === "agency" || uploadType === "msp")
      && viewType !== "candidateList") || (uploadType === "Candidate" && viewType === "candidateList") ? wfTask?.ciid : partnerCurrentWfTask?.ciid);
    frm.append("userId", currentUser.id);
    frm.append("signingMode", signingMode);
    dispatch(uploadToEsign(frm));
  };

  const handleOpenDocumentSignLink = async (docId) => {
    try {
      setEsignSignLinkLoadingId(docId);
      const response = await fetch(`${getWorkbenchApiBaseUrl()}/api/ReviewForm/GetDocumentESignSignLink?docId=${docId}&currentPerformerId=${currentUser?.id || 0}`);
      const data = await response.json().catch(() => null);

      if (!response.ok || !data?.signingLink) {
        // The API flags this user as not a designated signer (403 notAuthorized).
        // Older docs with no local signer roster surface the eSign service's
        // "no pending signer" 404 instead; treat both as the same authorization case.
        const notAuthorized =
          data?.notAuthorized === true ||
          response.status === 403 ||
          /no pending signer/i.test(data?.message || "");
        if (notAuthorized) {
          getAlert("", "You are not authorized to sign this document. Please contact your administrator.", "error");
        } else {
          getAlert("", data?.message || "Unable to create signing link.", "error");
        }
        return;
      }

      window.open(data.signingLink, "_blank");
    } catch (error) {
      getAlert("", "Unable to connect to eSign. Please try again.", "error");
    } finally {
      setEsignSignLinkLoadingId(null);
    }
  };

  const handleDeleteDocument = async (id) => {
    const result = await getConfirmAlert(
      "Warning",
      "Are you sure you want to Delete this Document?",
      "warning"
    );
    if (result.isConfirmed) dispatch(deleteDocument(id));
  };

  useEffect(() => {
    if (documentDeleteStatusSelector) {
      getAlert("", "Document Deleted Successfully", "success");
      //if (workflowTask?.ciid && viewType !== "candidateList") {
      if (wfTask?.ciid) {
        dispatch(loadDocuments(wfTask.ciid));
        dispatch(loadReqDocuments(wfTask.ciid));
      }
      // else if (partnerCurrentWfTask?.ciid) {
      //   dispatch(loadDocuments(partnerCurrentWfTask.ciid));
      //   dispatch(loadReqDocuments(partnerCurrentWfTask.ciid));
      // }
    }
  }, [documentDeleteStatusSelector]);

  const handlePurgeDocument = async (id) => {
    const result = await getConfirmAlert(
      "Warning",
      "Are you sure you want to Purge this Document?",
      "warning"
    );
    if (result.isConfirmed) dispatch(purgeDocument(id));
  };

  useEffect(() => {
    if (documentPurgeStatusSelector) {
      getAlert("", "Document Purged Successfully", "success");
      if (wfTask?.ciid && viewType !== "candidateList") {
        dispatch(loadDocuments(wfTask.ciid));
        dispatch(loadReqDocuments(wfTask.ciid));
      } else if (partnerCurrentWfTask?.ciid) {
        dispatch(loadDocuments(partnerCurrentWfTask.ciid));
        dispatch(loadReqDocuments(partnerCurrentWfTask.ciid));
      }
    }
  }, [documentPurgeStatusSelector]);

  const handleRollbackDocument = async (id) => {
    const result = await getConfirmAlert(
      "Warning",
      "Are you sure you want to Rollback this Document?",
      "warning"
    );
    if (result.isConfirmed) dispatch(rollbackDocument(id));
  };

  useEffect(() => {
    if (documentRollbackStatusSelector) {
      getAlert("", "Document Rollbacked Successfully", "success");
      //if (workflowTask?.ciid && viewType !== "candidateList") {
      if (wfTask?.ciid) {
        dispatch(loadDocuments(wfTask.ciid));
        dispatch(loadReqDocuments(wfTask.ciid));
      }
      // else if (partnerCurrentWfTask?.ciid) {
      //   dispatch(loadDocuments(partnerCurrentWfTask.ciid));
      //   dispatch(loadReqDocuments(partnerCurrentWfTask.ciid));
      // }
    }
  }, [documentRollbackStatusSelector]);

  const handleOtherDocShowHide = (type) => {
    setOtherDocShowHide(!otherDocShowHide);
    if (type === "save") {
      //if (workflowTask?.ciid && viewType !== "candidateList") {
      if (wfTask?.ciid) {
        dispatch(loadReqDocuments(wfTask.ciid));
        dispatch(loadDocuments(wfTask.ciid));
      }
      // else if (partnerCurrentWfTask?.ciid) {
      //   dispatch(loadReqDocuments(partnerCurrentWfTask?.ciid));
      //   dispatch(loadDocuments(partnerCurrentWfTask?.ciid));
      // }
    }
  };

  const getReqUploadedDocs = (item, type) => {
    const achDocs = appDocuments.filter(
      (x) => x.updType === `req_${!item.id ? item.docId : item.id}` && x.deleteFlag !== true
    );
    if (achDocs.length === 0) {
      return (
        <>
          {/* <td></td> */}
          <td>
            {type === "req" ? <>
              <button
                type="button"
                className="btn btn-sm btn-action-upload"
                onClick={() => handleDocShowHide("upload", `req_${!item.id ? item.docId : item.id}`)}
                // disabled={
                //   viewType === "candidateList" &&
                //   (uploadType === "Subcontractor" ||
                //     uploadType === "Recruiter")
                // }
                disabled={item.sendStatus !== true}
              >
                <i className="fa fa-upload mr-1"></i> Upload
              </button>
            </> : <span className="badge-status done">Done</span>}</td>
        </>
      );
    }

    if (achDocs.length > 0) {
      const doc = achDocs[0];
      return (
        <>
          {/* <td>
          <button
            className="btn btn-link btn-sm p-0"
            title="Download Document"
            onClick={() => handleDownloadFile(doc)
            }
          >
            {doc.docName}
          </button>
          {getPopover(doc.remarks)}
        </td> */}
          <td><span className="badge-status done">Done</span></td>
        </>
      );
    }
  };

  const handleViewSignedDoc = async (item, type) => {
    if (!item?.id) {
      getAlert("", "Signed document information is unavailable.", "error");
      return;
    }

    setSelectedSignedDoc({ ...item, downloadType: type });
    setSignLoading(true);

    try {
      const signedDocument = await dispatch(loadSignedDocument(item.id, type));
      if (signedDocument?.uploadUrl) {
        window.open(signedDocument.uploadUrl, "_blank");
      } else {
        getAlert("", "Unable to download the signed document.", "error");
      }
    } finally {
      setSelectedSignedDoc(null);
      setSignLoading(false);
      dispatch(signedDocumentReceived(null));
    }
  };

  const handleContractShowHide = (type, reqDoc = null, mapping = null) => {
    setSelectedReqDoc(reqDoc);
    setSelectedReqDocMapping(mapping);
    if (type === "save") {
      if (wfTask?.ciid) dispatch(loadDocuments(wfTask.ciid));
      setContractShowHide(false);
    } else {
      setTimeout(() => {
        setContractShowHide(!contractShowHide);
      }, 1000);
    }
  };

  const handleSendReqDocument = async (id) => {
    const result = await getConfirmAlert(
      "Warning",
      "Are you sure you want to Send this Document?",
      "warning"
    );
    if (result.isConfirmed) {
      setLoadingDocId(id);
      dispatch(sendReqDocuments(id));
    }
  };

  const handleDeleteReqDocument = async (id) => {
    const result = await getConfirmAlert(
      "Warning",
      "Are you sure you want to Delete this Document?",
      "warning"
    );
    if (result.isConfirmed) dispatch(deleteReqDocument(id));
  };

  useEffect(() => {
    if (reqDocSendStatusSelector) {
      getAlert("", "Document Sent Successfully", "success");
      setLoadingDocId(null);
      if (wfTask?.ciid) {
        dispatch(loadDocuments(wfTask.ciid));
        dispatch(loadReqDocuments(wfTask.ciid));
      }
    }
  }, [reqDocSendStatusSelector]);

  useEffect(() => {
    if (reqDocDeleteStatusSelector && wfTask?.ciid) {
      getAlert("", "Document Delete Successfully", "success");
      if (wfTask?.ciid) {
        dispatch(loadDocuments(wfTask.ciid));
        dispatch(loadReqDocuments(wfTask.ciid));
      }
    }
  }, [reqDocDeleteStatusSelector]);

  const handleDocumentLoad = (forceRefresh = false) => {
    const activeCiid =
      wfTask?.ciid ||
      workflowTask?.ciid ||
      partnerCurrentWfTask?.ciid ||
      candidateCurrentWfTaskSelector?.ciid ||
      subsCurrentWfTaskSelector?.ciid ||
      recCurrentWfTaskSelector?.ciid;

    if (activeCiid) {
      dispatch(loadDocuments(activeCiid, forceRefresh));
      dispatch(loadReqDocuments(activeCiid, forceRefresh));
      dispatch(loadDdrmsRepositoryDocs(activeCiid));
    }

    const signerId =
      uploadType === "Subcontractor"
        ? (applicantObj?.subcontractor?.parentid || applicantObj?.id)
        : uploadType === "Recruiter"
          ? (applicantObj?.recruiter?.parentid || applicantObj?.id)
          : (applicantObj?.id || applicantObj?.subcontractor?.parentid || applicantObj?.recruiter?.parentid);

    if (signerId) {
      dispatch(loadEsignDocuments(signerId, currentUser?.id));
    }
  };

  const handleBulkUploadComplete = () => {
    handleDocumentLoad(true);
    // Safety delay to capture any async server-side document processing
    setTimeout(() => {
      handleDocumentLoad(true);
      const flowType =
        getDefaultDocumentFlowType(app?.applicationType, viewType, uploadType);
      if (flowType) {
        dispatch(loadDefaultDocumentsConfig(flowType));
      }
    }, 1500);
  };

  const handleCopyClipboard = (text) => {
    navigator.clipboard.writeText(window.location.origin + text);
    setCopyItem(window.location.origin + text);
    setTimeout(() => {
      setCopyItem("");
    }, 3000);
  };

  const handleDocStatusChange = (docId, status) => {
    dispatch(updateReceivedDocStatus(docId, status));
  };

  const getSignedDocuments = (item, signType) => {
    const signDoc = esignDocuments.filter((x) => x.docData === item.docData);
    if (signDoc.length === 0) {
      var chkFirstSign = esignDocuments.filter(
        (x) =>
          x.docData === item.docData &&
          x.status === true &&
          x.signedStatus === "0" &&
          x.sendStatus !== true
      );
      if (chkFirstSign.length > 0) {
        return (
          <>
            {item.docType === "application/pdf" && (
              <a
                className="btn btn-sm btn-action-esign p-0"
                target="blank"
                //onClick={() => handleSendeSignDoc(item.docId)}
                href={`${process?.env?.REACT_APP_ESIGN_BASEURL}/${chkFirstSign[0]?.id
                  }_${((uploadType === "Subcontractor" ||
                    uploadType === "Recruiter") &&
                    viewType !== "candidateList") ||
                    (uploadType === "Candidate" && viewType === "candidateList")
                    ? wfTask?.ciid
                    : partnerCurrentWfTask?.ciid
                  }_${currentUser?.id}_${clientDetails?.clientId}_${item.docName
                  }_contractSigned`}
              >
                <i className="fa fa-pencil-square-o mr-1"></i> WF eSign
              </a>
            )}
            <br />
            <span className="badge-status pending">Pending</span>
          </>
        );
      } else {
        var chkSingleSign = esignDocuments.filter(
          (x) =>
            x.docData === item.docData &&
            x.signedStatus === null &&
            x.sendStatus === true
        );

        if (chkSingleSign.length > 0 && signType === "0")
          return (
            <>
              <span className="badge-status not-applicable">Not Applicable</span>
            </>
          );
        return <span className="badge-status pending">Pending</span>;
      }
    }

    if (signDoc.length > 0) {
      const doc = signDoc[0];
      const docSignType = signDoc.filter((x) => x.signedStatus === signType);
      if (docSignType.length === 0 && doc.signedStatus !== "1")
        return (
          <>
            {item.docType === "application/pdf" && !item.sentStatus && (
              <a
                className="btn btn-sm btn-action-esign p-0"
                target="blank"
                //onClick={() => handleSendeSignDoc(item.docId)}
                href={`${process?.env?.REACT_APP_ESIGN_BASEURL}/${signDoc[0]?.id
                  }_${((uploadType === "Subcontractor" ||
                    uploadType === "Recruiter") &&
                    viewType !== "candidateList") ||
                    (uploadType === "Candidate" && viewType === "candidateList")
                    ? wfTask?.ciid
                    : partnerCurrentWfTask?.ciid
                  }_${currentUser?.id}_${clientDetails?.clientId}_${item.docName
                  }_contractSigned`}
              >
                <i className="fa fa-pencil-square-o mr-1"></i> WF eSign
              </a>
            )}
            <br />
            <span className={`badge-status ${signType === "0" ? "not-applicable" : "pending"}`}>
              {signType === "0" ? "Not Applicable" : "Pending"}
            </span>
          </>
        );

      if (
        docSignType.length === 0 &&
        doc.signedStatus === "1" &&
        doc.signedDocUrl === null
      )
        return (
          <>
            <span className="badge-status not-applicable">Not Applicable</span>
          </>
        );

      return (
        <>
          <button
            className="btn btn-sm btn-action-download p-0"
            title="Download Document"
            onClick={() => handleViewSignedDoc(doc, signType)}
          >
            <i className="fa fa-download mr-1"></i> Download/View
          </button>
          <br />
          <span className="badge-status done">Done</span>
        </>
      );
    }
  };

  const getDocReqSize = (item) => {
    if (item.refDocId > 0) {
      const findDocs = appDocumentSelector.filter(
        (x) => x.uploadId === item.refDocId
      );
      if (findDocs.length > 0) {
        return (
          <>
            {findDocs.map((doc) => (
              <td>{doc.docSize}</td>
            ))}
          </>
        );
      }
    } else {
      return (
        <>
          <td></td>
        </>
      );
    }
  };

  const getReqRefDocs = (item) => {
    if (item.refDocId > 0) {
      const findDocs = appDocumentSelector.filter(
        (x) => x.uploadId === item.refDocId
      );
      if (findDocs.length > 0) {
        return (
          <>
            {findDocs.map((doc) => (
              <td>
                <button
                  className="btn btn-link btn-sm p-0"
                  title="Download Document"
                  onClick={() => handleDownloadFile(doc)}
                >
                  {doc.docName}
                </button>
                <br />
                {item.documnetName}
              </td>
            ))}
          </>
        );
      }
    }

    return <td>{item.documnetName}</td>;
  };

  const getPopover = (notes, uniqueId) => {
    const popover = (
      <Popover id={`popover-${uniqueId}`}>
        <Popover.Title as="h4">Notes</Popover.Title>
        <Popover.Content>{notes}</Popover.Content>
      </Popover>
    );
    return (
      <React.Fragment>
        <OverlayTrigger
          trigger={[]}
          placement="top"
          overlay={popover}
          show={activeNotesDocId === uniqueId}
          onToggle={(show) => {
            if (!show) setActiveNotesDocId(null);
          }}
          rootClose
        >
          <button
            type="button"
            className="pdm-btn pdm-btn-sm"
            onClick={(e) => {
              e.stopPropagation();
              setActiveNotesDocId(activeNotesDocId === uniqueId ? null : uniqueId);
            }}
          >
            <i className="fa fa-sticky-note-o" /> Notes
          </button>
        </OverlayTrigger>
      </React.Fragment>
    );
  };

  const normalizeDate = (dt) => {
    if (!dt) return 0;
    return new Date(dt).getTime(); // safely converts ISO-like strings
  };

  const handlePurchaseShowHide = (item, type, poOrderType) => {
    // setSelectedDocId(0);
    // setSelectedDoc(null);
    // setPoOrderType(poOrderType);
    // setPurchaseShowHide(true);
    // if (item) {
    //     setSelectedItem(item);
    // }
  }

  const handleSignUnsignPo = (poOrder) => {
    // Logic to sign or unsign the purchase order
  }
  const handleRefreshPoOrders = () => {
    // Logic to refresh the purchase orders
    // if (uploadType !== "Recruiter")
    //   handleModalShowHide("save");
  }

  const clientDocs = appDocuments.filter((x) => x.uploadType === "agency");
  const mspDocs = appDocuments.filter((x) => x.uploadType === "msp");
  let filterDocs = appDocuments.filter(
    (x) => x.updType !== "Messaging" && x.deleteFlag !== true
  );

  let filterAgencyMspDocs = uploadType === "msp" ? mspDocs : clientDocs;
  let receviedDocumnets = filterDocs.filter(
    (x) => !x.uploadType?.includes("_c2c_")
  );

  const ppDocs = filterDocs.filter(
    (x) => x.uploadType?.includes("_c2c_") && x.sentStatus === true
  );
  if (ppDocs.length > 0) {
    receviedDocumnets = [...receviedDocumnets, ...ppDocs];
  }

  if (viewType === "candidateList") {
    if (
      applicantObj?.subcontractor?.parentid > 0 &&
      uploadType === "Subcontractor"
    ) {
      receviedDocumnets = receviedDocumnets.filter(
        (x) => x.uploaderId === applicantObj?.subcontractor?.parentid
      );
    } else if (
      applicantObj?.recruiter?.parentid > 0 &&
      uploadType === "Recruiter"
    ) {
      receviedDocumnets = receviedDocumnets.filter(
        (x) => x.uploaderId === applicantObj?.recruiter?.parentid
      );
    } else if (uploadType === "Candidate") {
      receviedDocumnets = receviedDocumnets.filter(
        (x) => x.uploaderId === applicantObj?.id
      );
    }
  }

  let sentDocuments = filterDocs.filter(
    (x) => x.deleteFlag !== true && x.uploaderId !== applicantObj?.id
  );

  let filterReqDocs = reqDocuments.filter(
    (x) => x.performerId === applicantObj?.id
  );

  if (
    applicantObj?.subcontractor?.parentid > 0 &&
    uploadType === "Subcontractor"
  ) {
    sentDocuments = filterDocs.filter(
      (x) =>
        x.deleteFlag !== true &&
        x.uploaderId !== applicantObj?.subcontractor?.parentid &&
        x.uploaderId !== applicantObj?.id &&
        x.receiverId !== applicantObj?.id
    );
    filterReqDocs = reqDocuments.filter(
      (x) => x.performerId === applicantObj?.subcontractor?.parentid
    );
  }

  if (applicantObj?.recruiter?.parentid > 0 && uploadType === "Recruiter") {
    sentDocuments = filterDocs.filter(
      (x) =>
        x.deleteFlag !== true &&
        x.uploaderId !== applicantObj?.recruiter?.parentid &&
        x.uploaderId !== applicantObj?.id &&
        x.receiverId !== applicantObj?.id
    );

    filterReqDocs = reqDocuments.filter(
      (x) => x.performerId === applicantObj?.recruiter?.parentid
    );
  }

  const sentAgencyMapDocuments = filterAgencyMspDocs.filter(
    (x) => x.deleteFlag !== true
  );

  const deletedDocumnets = appDocuments.filter((x) => x.deleteFlag === true);
  const deletedAgencyMspDocumnets = appDocuments.filter(
    (x) => x.deleteFlag === true && x.uploadType === `${uploadType}`
  );

  let mergeReceivedDocs = [
    ...sentDocuments
      .filter(
        (x) =>
          x.uploadType !== "client" &&
          x.uploadType !== "reporting" &&
          x.uploadType !== "project" &&
          x.uploadType !== "agency" &&
          x.uploadType !== "msp" &&
          x.uploadType !== "ProjectInfo" &&
          x.updType !== "internal" &&
          x.updType !== "Invoice" &&
          !x.updType?.includes("req_")
      )
      .map((x) => ({
        ...x,
        __docType: "sent",
        finalDateTime: moment(x.dateTime), // moment object
      })),
    ...filterReqDocs.map((f) => ({
      ...f,
      __docType: "req",
      finalDateTime: moment(f.addedDateTime), // moment object
    })),
  ];

  let sortMergedDocs = mergeReceivedDocs.sort(
    (a, b) => b.finalDateTime.valueOf() - a.finalDateTime.valueOf()
  );

  const getRequiredDocumentId = (item) => (!item.id ? item.docId : item.id);
  const getUploadedRequiredDocuments = (item) =>
    appDocuments.filter(
      (x) => x.updType === `req_${getRequiredDocumentId(item)}` && x.deleteFlag !== true
    );
  const visibleRequiredDocuments = sortMergedDocs
    .filter((d) => d.__docType === "req")
    .map((item) => ({
      item,
      uploadedDocs: getUploadedRequiredDocuments(item),
    }))
  //.filter(({ item, uploadedDocs }) => item.sendStatus || uploadedDocs.length > 0);
  const visibleDocumentRows = [
    ...sortMergedDocs.filter((d) => d.__docType === "sent"),
    ...visibleRequiredDocuments.map(({ item }) => item),
  ];

  const visibleAgencyMspDocuments = sentAgencyMapDocuments.filter(
    (x) =>
      x.uploadType !== "client" &&
      x.uploadType !== "reporting" &&
      x.uploadType !== "project" &&
      x.uploadType !== "candidate" &&
      x.uploadType !== "ProjectInfo" &&
      x.updType !== "internal"
  );
  const uploadedDocumentsCount =
    uploadType === "agency" || uploadType === "msp"
      ? visibleAgencyMspDocuments.length
      : visibleDocumentRows.length;
  const nonDeletedDocs = appDocuments.filter(
    (x) => x.deleteFlag !== true && x.updType !== "Messaging"
  );
  const hasContractDocuments = uploadedDocumentsCount > 0;
  const currentFlowType =
    getDefaultDocumentFlowType(app?.applicationType, viewType, uploadType);

  // When API brings documents, automatically switch to current document section
  useEffect(() => {
    if (hasContractDocuments) {
      setViewOverride(null);
    }
  }, [hasContractDocuments]);

  const normalizeDocText = (text) =>
    String(text || "")
      .toLowerCase()
      .replace(/\.[a-z0-9]+$/i, "")
      .replace(/[^a-z0-9]/g, "")
      .trim();

  const isDefaultDocUploaded = (defaultDoc) => {
    if (!defaultDoc) return false;

    // 1. Purchase Orders
    const isPO =
      Boolean(defaultDoc?.purchaseOrderType) ||
      String(defaultDoc?.name || "").trim().toLowerCase().startsWith("purchase order");

    if (isPO) {
      const poType = String(defaultDoc?.purchaseOrderType || "").toLowerCase();
      const hasPOInAppDocs = appDocuments.some((d) => {
        if (d.deleteFlag === true) return false;
        const name = String(d.docName || "").toLowerCase();
        if (!name.includes("purchase order") && !name.includes("purchaseorder") && !name.includes(" po ")) return false;
        if (poType === "recruiter") {
          return name.includes("recruiter") || name.includes("rec");
        }
        if (poType === "subcontractor") {
          return name.includes("subcontractor") || name.includes("sub") || (!name.includes("recruiter") && !name.includes("rec"));
        }
        return true;
      });
      if (hasPOInAppDocs) return true;

      if (Array.isArray(applicantObj?.purchaseOrders) && applicantObj.purchaseOrders.length > 0) {
        if (poType === "recruiter") {
          return applicantObj.purchaseOrders.some((po) => po.partnerType?.toLowerCase().includes("rec"));
        }
        if (poType === "subcontractor") {
          return applicantObj.purchaseOrders.some((po) => po.partnerType?.toLowerCase().includes("sub"));
        }
        return true;
      }
      return false;
    }

    const defaultNorm = normalizeDocText(defaultDoc.name);

    // 2. Required Document upload check (by reqDocId or doc name matching visibleRequiredDocuments)
    if (defaultDoc.reqDocId) {
      const hasUploadedById = appDocuments.some(
        (x) =>
          x.deleteFlag !== true &&
          (x.updType === `req_${defaultDoc.reqDocId}` || Number(x.uploadId) === Number(defaultDoc.reqDocId))
      );
      if (hasUploadedById) return true;
    }

    const matchingReq = visibleRequiredDocuments.find((v) => {
      const vNorm = normalizeDocText(v.item?.documnetName);
      return (
        (defaultDoc.reqDocId && Number(getRequiredDocumentId(v.item)) === Number(defaultDoc.reqDocId)) ||
        (defaultNorm && vNorm && (defaultNorm === vNorm || defaultNorm.includes(vNorm) || vNorm.includes(defaultNorm)))
      );
    });

    if (matchingReq) return true;

    const hasInReqDocs = reqDocuments.some((r) => {
      const rNorm = normalizeDocText(r.documnetName);
      return (
        (defaultDoc.reqDocId && Number(getRequiredDocumentId(r)) === Number(defaultDoc.reqDocId)) ||
        (defaultNorm && rNorm && (defaultNorm === rNorm || defaultNorm.includes(rNorm) || rNorm.includes(defaultNorm)))
      );
    });
    if (hasInReqDocs) return true;

    // 3. Sent / Generated / Direct uploaded documents check in appDocuments or sortMergedDocs
    const matchingAppDoc = appDocuments.some((d) => {
      if (d.deleteFlag === true || d.updType === "Messaging") return false;
      const dNorm = normalizeDocText(d.docName);
      if (!dNorm || !defaultNorm) return false;
      return dNorm === defaultNorm || dNorm.includes(defaultNorm) || defaultNorm.includes(dNorm);
    });
    if (matchingAppDoc) return true;

    // 4. DDRMS document matching if doc has ddrmsDocId
    if (defaultDoc.ddrmsDocId) {
      const ddrmsItem = ddrmsDocsSelector?.find(
        (dd) => Number(dd.id || dd.docId) === Number(defaultDoc.ddrmsDocId)
      );
      if (ddrmsItem?.name) {
        const ddrmsNorm = normalizeDocText(ddrmsItem.name);
        const matchDDRMS = appDocuments.some((d) => {
          if (d.deleteFlag === true) return false;
          const dNorm = normalizeDocText(d.docName);
          return dNorm && ddrmsNorm && (dNorm === ddrmsNorm || dNorm.includes(ddrmsNorm) || ddrmsNorm.includes(dNorm));
        });
        if (matchDDRMS) return true;
      }
    }

    return false;
  };

  const pendingDefaultDocuments = useMemo(() => {
    if (!currentFlowType) return [];
    return (defaultC2CDocuments || []).filter(
      (doc) => !isDefaultDocUploaded(doc)
    );
  }, [currentFlowType, defaultC2CDocuments, appDocuments, visibleRequiredDocuments, reqDocuments, ddrmsDocsSelector, applicantObj]);

  const renderDefaultDocuments = (isEmbedded = false, docsToRender = null, customTitle = "") => {
    if (!currentFlowType) return null;
    const documentsForModal = docsToRender || (isEmbedded ? pendingDefaultDocuments : defaultC2CDocuments);
    return (
      <DefaultDocumentsModal
        show={!isEmbedded ? showDefaultDocsModal : true}
        embedded={isEmbedded}
        title={customTitle}
        onHide={() => {
          if (!isEmbedded) setShowDefaultDocsModal(false);
        }}
        onToggleView={hasContractDocuments ? () => setViewOverride("current") : undefined}
        defaultDocuments={documentsForModal}
        onSave={handleSaveAndLoadDefaultDocs}
        onBulkUploadComplete={handleBulkUploadComplete}
        onDocumentUploaded={handleDocumentLoad}
        reqDocuments={onReqDocs}
        dataTypeMappings={dataTypeMappingsSelector}
        ddrmsDocs={ddrmsDocsSelector}
        performerType={currentFlowType}
        renderPurchaseOrder={viewType === "candidateList" ? (
          doc,
          closeTab,
          { autoProcess = false, footerContainer = null, stagedGenerated = null, onStageGenerated = null } = {},
          purchaseOrderAction = "generate"
        ) => (
          <PurchaseOrderPopup
            key={`default-po-${doc.purchaseOrderType || doc.name}-${autoProcess ? "bulk" : "manual"}`}
            purchaseShowHide
            hideHeader
            candidateObj={applicantObj}
            workflowTask={wfTask || partnerCurrentWfTask}
            poOrderType="add"
            item={{
              partnerType: doc.purchaseOrderType === "recruiter" || uploadType === "Recruiter"
                ? "Recruiter"
                : "Sub-Contractors"
            }}
            handlePurchaseShowHide={handlePurchaseShowHide}
            handleSignUnsignPo={handleSignUnsignPo}
            handleRefreshPoOrders={() => {
              handleRefreshPoOrders();
              if (!autoProcess) handleDocumentLoad();
            }}
            renderType="generate"
            initialPoType={doc.purchaseOrderType || (uploadType === "Recruiter" ? "recruiter" : "")}
            autoAction={purchaseOrderAction}
            embeddedGenerator
            footerContainer={footerContainer}
            autoSave={autoProcess}
            deferSave={!autoProcess && Boolean(onStageGenerated)}
            initialGeneratedData={stagedGenerated}
            onStageGenerated={onStageGenerated}
            onEmbeddedClose={(completed = false, actionType = "save") => closeTab(completed, actionType)}
          />
        ) : undefined}
        renderGenerate={(doc, closeTab, { autoProcess = false, stagedGenerated = null, onStageGenerated = null } = {}) => (
          <GenerateContract
            key={`default-generate-${doc.ddrmsDocId}-${doc.mappingId}`}
            embedded
            bodyOnly
            autoSave={autoProcess}
            deferSave={!autoProcess && Boolean(onStageGenerated)}
            initialGeneratedData={stagedGenerated}
            onStageGenerated={onStageGenerated}
            showHide
            uploadType={uploadType}
            handleModalShowHide={(type) => {
              if (type === "save" && !autoProcess) handleDocumentLoad();
              closeTab(type === "save" || type === "stage", type);
            }}
            workflowTask={((uploadType === "Subcontractor" || uploadType === "Recruiter" || uploadType === "agency" || uploadType === "msp") && viewType !== "candidateList") || (uploadType === "Candidate" && viewType === "candidateList") ? wfTask : (partnerCurrentWfTask || wfTask)}
            app={app}
            applicantObj={applicantObj}
            prevItem={prevItem}
            viewType={viewType}
            ddrmsDocId={doc.ddrmsDocId}
            defaultMappingId={doc.mappingId}
          />
        )}
        renderUploadReference={(doc, closeTab, { autoProcess = false, stagedReference = null, onStageReference = null } = {}) => {
          const task = (((uploadType === "Subcontractor" || uploadType === "Recruiter" || uploadType === "agency" || uploadType === "msp") && viewType !== "candidateList") || (uploadType === "Candidate" && viewType === "candidateList")) ? wfTask : (partnerCurrentWfTask || wfTask);
          const loadedRequiredDocument = reqDocuments.find(
            (item) => item.documnetName?.trim().toLowerCase() === doc.name?.trim().toLowerCase()
          );
          // Reuse the existing row's identity but never its old reference: a fresh
          // upload attaches a reference only when the user actually picks one. Keeping
          // refDocId here made a no-file upload re-attach the previous reference doc.
          const requiredDocument = loadedRequiredDocument
            ? { ...loadedRequiredDocument, refDocId: null }
            : {
              id: 0,
              formId: 0,
              documnetName: doc.name,
              notes: "Default Document Reference",
              ciid: task?.ciid,
              iiid: task?.iiid,
              wiid: task?.wiid,
              performerId: getReqDocPerformerId(task)
            };

          return (
            <UploadOther
              key={`default-upload-${doc.reqDocId || doc.name}`}
              embedded
              bodyOnly
              showBodyOnlyFooter={!autoProcess}
              autoSubmit={autoProcess}
              deferSubmit={!autoProcess && Boolean(onStageReference)}
              initialReferenceData={stagedReference}
              onStageReference={onStageReference}
              hideAddWithoutReference={true}
              handleOtherDocShowHide={(type) => {
                if (type === "save" && !autoProcess) {
                  handleDocumentLoad();
                }
                closeTab(type === "save" || type === "stage", type);
              }}
              otherDocShowHide
              workflowTask={task}
              onReqDocs={onReqDocs}
              uploadType={uploadType}
              viewType={viewType}
              applicantObj={applicantObj}
              prevItem={prevItem}
              requiredDocument={requiredDocument}
            />
          );
        }}
      />
    );
  };
  const visibleDeletedDocuments =
    uploadType === "agency" || uploadType === "msp"
      ? deletedAgencyMspDocumnets
      : deletedDocumnets.filter((x) => x.uploadType !== "msp" && x.uploadType !== "agency");
  const completedRequiredDocs = filterReqDocs.filter((item) =>
    appDocuments.some(
      (x) =>
        x.updType === `req_${!item.id ? item.docId : item.id}` &&
        x.deleteFlag !== true
    )
  ).length;
  const sentCompletedDocs = sentDocuments.filter(
    (x) =>
      x.sentStatus === true &&
      x.uploadType !== "client" &&
      x.uploadType !== "reporting" &&
      x.uploadType !== "project" &&
      x.uploadType !== "agency" &&
      x.uploadType !== "msp" &&
      x.updType !== "internal"
  ).length;
  const documentStatusLabel = applicantObj
    ? ((applicantObj.contact1?.isActive === true || applicantObj.isActive === true)
      ? "Active"
      : (applicantObj.contact1?.isActive === false || applicantObj.isActive === false)
        ? "Inactive"
        : "Pending Activation")
    : "New";
  const documentStatusClass =
    documentStatusLabel === "Active"
      ? "meta-status-active"
      : documentStatusLabel === "Inactive"
        ? "meta-status-inactive"
        : "meta-status-pending";

  return (
    <React.Fragment>
      <div className={`pdm-root${embedded ? " pdm-root-embedded" : ""}`}>
        <style dangerouslySetInnerHTML={{
          __html: `
          .pdm-root {
            --c-bg: #ffffff;
            --c-surface: #f8fafc;
            --c-canvas: #f3f6fb;
            --c-border: #e2e8f0;
            --c-border-light: #f1f5f9;
            --c-text: #0f172a;
            --c-text-2: #475569;
            --c-text-3: #94a3b8;

            --c-indigo: #2563eb;
            --c-indigo-h: #1d4ed8;
            --c-indigo-s: #eff6ff;
            --c-indigo-m: #bfdbfe;

            --c-violet: #2563eb;
            --c-violet-s: #eff6ff;

            --c-green: #16a34a;
            --c-green-s: #f0fdf4;

            --c-amber: #d97706;
            --c-amber-s: #fffbeb;

            --c-rose: #e11d48;
            --c-rose-s: #fff1f2;

            --c-sky: #0284c7;
            --c-sky-s: #f0f9ff;

            --r-sm: 0;
            --r-md: 0;
            --r-lg: 0;
            --r-xl: 0;

            --sh-sm: 0 1px 2px rgba(0,0,0,.05);
            --sh-md: 0 4px 12px rgba(0,0,0,.06);
            --sh-lg: 0 8px 24px rgba(0,0,0,.07);

            font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
            background: var(--c-canvas);
            border: 1px solid rgba(226, 232, 240, 0.9);
            border-radius: 0;
            overflow: hidden;
            box-shadow: 0 18px 45px rgba(15, 23, 42, 0.07);
          }

          /* â”€â”€ Header bar â”€â”€ */
          .pdm-header {
            display: flex;
            align-items: flex-start;
            justify-content: space-between;
            flex-wrap: wrap;
            gap: 18px;
            padding: 22px 24px 18px;
            background: #ffffff;
            border-bottom: 1px solid #d1d5db;
          }
          .pdm-header-left {
            display: flex;
            align-items: flex-start;
            gap: 14px;
            min-width: 260px;
            flex: 1 1 360px;
          }
          .pdm-icon-box {
            width: 44px;
            height: 44px;
            border-radius: 0;
            background: #f3f4f6;
            border: 1px solid #d1d5db;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #525252;
            font-size: 18px;
            flex-shrink: 0;
            box-shadow: none;
          }
          .pdm-title-block {
            min-width: 0;
          }
          .pdm-kicker {
            display: inline-flex;
            align-items: center;
            gap: 6px;
            margin: 0 0 5px;
            color: #64748b;
            font-size: 12px;
            font-weight: 600;
            letter-spacing: 0.08em;
            text-transform: uppercase;
          }
          .pdm-title {
            font-size: 18px;
            font-weight: 500;
            color: #1e293b;
            margin: 0;
            line-height: 1.2;
          }
          .pdm-subtitle {
            font-size: 14px;
            font-weight: 400;
            color: #64748b;
            margin: 6px 0 0;
            max-width: 620px;
          }
          .pdm-header-actions {
            display: flex;
            align-items: center;
            gap: 8px;
            flex-wrap: wrap;
            justify-content: flex-end;
          }
          .pdm-header-meta {
            display: flex;
            align-items: center;
            gap: 7px;
            flex-wrap: wrap;
            margin-top: 10px;
          }
          .pdm-meta-pill {
            display: inline-flex !important;
            align-items: center !important;
            gap: 5px !important;
            padding: 3px 8px !important;
            height: 24px !important;
            min-height: 24px !important;
            box-sizing: border-box !important;
            border-radius: 0 !important;
            background: #ffffff !important;
            border: 1px solid #cbd5e1 !important;
            color: #0f172a !important;
            font-size: 11px !important;
            font-weight: 600 !important;
            font-family: "Open Sans", sans-serif !important;
            box-shadow: none !important;
          }
          .pdm-meta-pill i { font-size: 11px !important; }
          .pdm-meta-pill.meta-id i {
            color: #334155;
          }
          .pdm-meta-pill.meta-person i {
            color: #6d28d9;
          }
          .pdm-meta-pill.meta-email i {
            color: #0369a1;
          }
          .pdm-meta-pill.meta-status-active i {
            color: #15803d;
          }
          .pdm-meta-pill.meta-status-inactive i {
            color: #b91c1c;
          }
          .pdm-meta-pill.meta-status-pending i {
            color: #b45309;
          }
          .pdm-meta-pill.meta-ciid i {
            color: #0f766e;
          }
          .pdm-summary-grid {
            display: grid;
            grid-template-columns: repeat(5, minmax(130px, 1fr));
            gap: 10px;
            padding: 14px 24px 16px;
            background: var(--c-bg);
            border-bottom: 1px solid var(--c-border-light);
          }
          .pdm-stat-card {
            display: flex;
            align-items: center;
            gap: 10px;
            min-width: 0;
            padding: 12px;
            border: 1px solid var(--c-border-light);
            border-radius: 0;
            background: #ffffff;
            box-shadow: var(--sh-sm);
          }
          .pdm-stat-icon {
            width: 34px;
            height: 34px;
            border-radius: 0;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            flex: 0 0 34px;
            background: var(--c-indigo-s);
            color: var(--c-indigo);
          }
          .pdm-stat-icon.is-green { background: var(--c-green-s); color: var(--c-green); }
          .pdm-stat-icon.is-amber { background: var(--c-amber-s); color: var(--c-amber); }
          .pdm-stat-icon.is-rose { background: var(--c-rose-s); color: var(--c-rose); }
          .pdm-stat-icon.is-sky { background: var(--c-sky-s); color: var(--c-sky); }
          .pdm-stat-label {
            display: block;
            color: #64748b;
            font-size: 12px;
            font-weight: 600;
            letter-spacing: 0.05em;
            text-transform: uppercase;
          }
          .pdm-stat-value {
            display: block;
            color: #1e293b;
            font-size: 14px;
            font-weight: 400;
            line-height: 1.1;
          }

          /* â”€â”€ Modern Rich UI Custom Tabs â”€â”€ */
          .pdm-tabs-wrap {
            padding: 16px 24px 0;
            background: var(--c-bg);
          }
          .custom-tabs-container {
            margin-bottom: 12px !important;
            position: relative !important;
          }
          /* Segmented control, matching the Contract Documents / ACH / Insurance
             chips in ReviewTask: recessed track, active tab lifts out as a pill. */
          .custom-tabs-list {
            display: flex !important;
            align-items: center !important;
            gap: 4px !important;
            margin: 0 !important;
            padding: 4px !important;
            list-style: none !important;
            width: fit-content !important;
            max-width: 100% !important;
            flex-wrap: wrap !important;
            background: #f1f5f9 !important;
            border: 1px solid #e2e8f0 !important;
            border-radius: 0 !important;
            position: relative !important;
          }
          .custom-tab-item {
            position: relative !important;
            display: inline-flex !important;
            align-items: center !important;
            gap: 7px !important;
            border: 1px solid transparent !important;
            background: transparent !important;
            padding: 7px 13px !important;
            font-size: 14px !important;
            font-weight: 500 !important;
            color: #64748b !important;
            cursor: pointer !important;
            border-radius: 0 !important;
            transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
            outline: none !important;
            box-shadow: none !important;
            white-space: nowrap !important;
            user-select: none !important;
          }
          .custom-tab-item:focus,
          .custom-tab-item:active,
          .custom-tab-item:focus-visible {
            outline: none !important;
            box-shadow: none !important;
          }
          .custom-tab-item:hover {
            color: #1e293b !important;
            background: rgba(255, 255, 255, 0.7) !important;
          }
          .custom-tab-item.active {
            color: #1d4ed8 !important;
            font-weight: 500 !important;
            background: #ffffff !important;
            border-color: #e2e8f0 !important;
            box-shadow: 0 1px 2px rgba(15, 23, 42, 0.06), 0 2px 5px -2px rgba(15, 23, 42, 0.08) !important;
          }
          .custom-tab-item.active:hover {
            background: #ffffff !important;
          }
          .custom-tab-item.active:focus,
          .custom-tab-item.active:active {
            box-shadow: 0 1px 2px rgba(15, 23, 42, 0.06), 0 2px 5px -2px rgba(15, 23, 42, 0.08) !important;
          }
          .custom-tab-item i {
            font-size: 14px !important;
            transition: color 0.2s ease, opacity 0.2s ease !important;
            color: inherit !important;
            opacity: 0.75 !important;
          }
          .custom-tab-item.active i {
            color: #1d4ed8 !important;
            opacity: 1 !important;
          }
          /* White, not #f1f5f9: the segmented track is that colour now and the
             badge would vanish into it. */
          .tab-count {
            display: inline-flex !important;
            align-items: center !important;
            justify-content: center !important;
            min-width: 19px !important;
            height: 18px !important;
            padding: 0 6px !important;
            border-radius: 0 !important;
            font-size: 12px !important;
            font-weight: 600 !important;
            font-variant-numeric: tabular-nums !important;
            background: #ffffff !important;
            color: #64748b !important;
            border: 1px solid #e2e8f0 !important;
            transition: all 0.25s ease !important;
            line-height: 1 !important;
            margin-left: 6px !important;
          }
          .custom-tab-item:hover .tab-count {
            background: #ffffff !important;
            border-color: #cbd5e1 !important;
            color: #475569 !important;
          }
          .custom-tab-item.active .tab-count {
            background: rgba(37, 99, 235, 0.1) !important;
            color: #1d4ed8 !important;
            border-color: rgba(37, 99, 235, 0.2) !important;
            box-shadow: none !important;
          }

          /* â”€â”€ Tab panel wrapper â”€â”€ */
          .pdm-root .tab-pane {
            padding: 0 !important;
            border: none !important;
            background: none !important;
          }
          .pdm-tab-body {
            padding: 10px 0 24px;
            min-height: 300px;
          }
          /* Purchase Order renders inside a tab here, so it does not need the
             lifted-card treatment it uses when shown as a standalone view. */
          .pdm-tab-body .pop-container {
            box-shadow: none;
          }

          /* â”€â”€ Toolbar inside tab â”€â”€ */
          .pdm-toolbar {
            display: flex;
            align-items: center;
            justify-content: space-between;
            flex-wrap: wrap;
            gap: 10px;
            margin-bottom: 16px;
          }
          .pdm-toolbar-left {
            display: flex;
            align-items: center;
            gap: 8px;
            flex-wrap: wrap;
          }

          /* â”€â”€ Buttons â”€â”€ */
          .pdm-btn {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            gap: 8px;
            background: #ffffff;
            border: 1px solid #d1d5db;
            padding: 8px 16px;
            border-radius: 0;
            font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
            font-size: 14px;
            font-weight: 500;
            color: #1e293b;
            cursor: pointer;
            transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
            box-sizing: border-box;
            min-height: 38px;
            text-decoration: none;
            white-space: nowrap;
            outline: none;
          }
          .pdm-btn:hover {
            background: #f5f5f5;
            color: #1e293b;
            border-color: #a3a3a3;
            transform: none;
            box-shadow: none;
          }
          .pdm-header-actions .pdm-btn i {
            color: #1e293b !important;
          }
          .pdm-btn-primary {
            background: #2563eb;
            color: #fff;
            border-color: #2563eb;
          }
          .pdm-btn-primary:hover {
            background: #1d4ed8;
            color: #ffffff;
            border-color: #1d4ed8;
            transform: translateY(-1px);
            box-shadow: 0 4px 10px -1px rgba(37, 99, 235, 0.25);
          }
          .pdm-btn-ghost { background: transparent; border-color: transparent; }
          .pdm-btn-ghost:hover { background: var(--c-surface); border-color: var(--c-border); }
          .pdm-btn-ghost-danger { background: rgba(239, 68, 68, 0.06); border-color: rgba(239, 68, 68, 0.18); color: #dc2626; }
          .pdm-btn-ghost-danger:hover { background: rgba(239, 68, 68, 0.12); border-color: rgba(239, 68, 68, 0.28); color: #b91c1c; transform: translateY(-1px); }
          .pdm-btn-ghost-violet { background: rgba(37, 99, 235, 0.08); border-color: rgba(37, 99, 235, 0.15); color: #1d4ed8; }
          .pdm-btn-ghost-violet:hover { background: rgba(37, 99, 235, 0.12); }
          .pdm-btn-ghost-indigo { background: #ffffff; border-color: #cbd5e1; color: #475569; }
          .pdm-btn-ghost-indigo:hover { background: #f8fafc; color: #0f172a; border-color: #94a3b8; }
          .pdm-btn-ghost-sky { background: var(--c-sky-s); border-color: transparent; color: var(--c-sky); }
          .pdm-btn-ghost-sky:hover { background: #bae6fd; }
          .pdm-btn-sm { padding: 8px 16px; font-size: 14px; min-height: 38px; }
          .pdm-btn:disabled {
            background: #f1f5f9;
            color: #94a3b8;
            border-color: #cbd5e1;
            cursor: not-allowed;
            transform: none;
            box-shadow: none;
            opacity: 0.75;
            pointer-events: none;
          }

          /* â”€â”€ Document card rows â”€â”€ */
          .pdm-doc-list {
            display: flex;
            flex-direction: column;
            gap: 8px;
          }
          .pdm-doc-row {
            display: grid;
            align-items: center;
            background: var(--c-bg);
            border: none;
            border-bottom: 1px solid #e2e8f0;
            border-radius: 0;
            padding: 14px 16px;
            gap: 12px;
            transition: background-color 0.15s ease, border-color 0.15s ease;
            position: relative;
          }
          .pdm-doc-row:hover {
            border-bottom-color: #cbd5e1;
            box-shadow: none;
            transform: none;
            z-index: 2;
          }
          .pdm-doc-row:focus-within {
            z-index: 10 !important;
          }
          .pdm-doc-row:has(.show) {
            z-index: 10 !important;
          }
          .pdm-doc-row-upload {
            grid-template-columns: 28px 1fr auto auto auto auto;
          }
          .pdm-doc-row-received {
            grid-template-columns: 24px 1fr auto auto auto;
          }
          .pdm-doc-row-deleted {
            grid-template-columns: 24px 1fr auto auto auto auto;
          }
          .pdm-doc-row-internal {
            grid-template-columns: 24px 1fr auto auto auto;
          }
          .pdm-doc-row-card {
            grid-template-columns: minmax(0, 1fr) auto;
            align-items: center;
            padding: 16px;
            border: none;
            border-bottom: 1px solid #e2e8f0;
            border-radius: 0;
            box-shadow: none;
          }
          .pdm-doc-row-card:hover {
            border-bottom-color: #cbd5e1;
            box-shadow: none;
          }
          .pdm-doc-file {
            display: flex;
            align-items: flex-start;
            gap: 12px;
            min-width: 0;
          }
          .pdm-doc-file-icon {
            width: 36px;
            height: 36px;
            border-radius: 0;
            background: #eff6ff;
            color: #2563eb;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            flex: 0 0 36px;
            font-size: 16px;
          }
          .pdm-doc-file-main {
            min-width: 0;
          }
          .pdm-doc-file-main .pdm-doc-name {
            font-size: 14px;
            font-weight: 400;
          }
          .pdm-doc-title-row {
            display: flex;
            align-items: center;
            gap: 8px;
            min-width: 0;
            max-width: 100%;
            flex-wrap: wrap;
            white-space: normal;
          }
          .pdm-doc-required-label {
            color: #1e293b;
            font-size: 14px;
            font-weight: 500;
            line-height: 1.3;
            white-space: normal;
          }
          .pdm-doc-title-separator {
            color: #94a3b8;
            font-weight: 400;
          }
          .pdm-doc-mini-badge {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            min-width: 30px;
            height: 18px;
            padding: 0 6px;
            border-radius: 0;
            background: #f8fafc;
            border: 1px solid #cbd5e1;
            color: #64748b;
            font-size: 12px;
            font-weight: 600;
            line-height: 1;
            margin-right: 6px;
          }
          .pdm-doc-mini-badge.is-rec {
            background: rgba(16, 185, 129, 0.08);
            border-color: rgba(16, 185, 129, 0.18);
            color: #047857;
          }
          .pdm-doc-title-row .pdm-doc-name-wrapper {
            flex: 0 1 auto;
            min-width: fit-content;
            max-width: 100%;
            white-space: normal;
          }
          .pdm-doc-title-row .pdm-doc-name {
            white-space: normal;
            overflow-wrap: anywhere;
          }
          .pdm-doc-title-row .pdm-doc-copy-btn,
          .pdm-doc-title-row .pdm-doc-mini-badge,
          .pdm-doc-title-row .pdm-doc-title-separator {
            flex: 0 0 auto;
          }
          .pdm-doc-esign-tag {
            display: inline-flex;
            align-items: center;
            gap: 4px;
            width: fit-content;
            padding: 2px 8px;
            border-radius: 0;
            background: rgba(37, 99, 235, 0.08);
            border: 1px solid rgba(37, 99, 235, 0.15);
            color: #1d4ed8;
            font-size: 12px;
            font-weight: 600;
            line-height: 1.2;
            white-space: nowrap;
          }
          .pdm-doc-subtitle {
            margin-top: 3px;
            color: #64748b;
            font-size: 14px;
            font-weight: 400;
          }
          .pdm-doc-actions-panel {
            display: flex;
            align-items: center;
            justify-content: flex-end;
            gap: 12px;
            align-self: center;
            min-width: 520px;
          }
          .pdm-action-slot {
            display: inline-flex;
            align-items: center;
            justify-content: flex-end;
            min-width: 0;
          }
          .pdm-action-slot .pdm-btn,
          .pdm-action-slot .pdm-badge {
            max-width: 100%;
          }
          .pdm-doc-status-stack {
            display: inline-flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            gap: 4px;
            min-width: 0;
          }
          .pdm-doc-status-stack .pdm-badge {
            padding: 5px 12px;
            justify-content: center;
            font-size: 12px;
            font-weight: 600;
          }
          .pdm-doc-status-date {
            color: #64748b;
            font-size: 12px;
            font-weight: 400;
            line-height: 1.1;
            text-align: center;
            white-space: nowrap;
          }
          .pdm-doc-actions-divider {
            width: 1px;
            height: 24px;
            background: var(--c-border);
            margin: 0 4px;
            align-self: center;
          }

          .pdm-doc-info {}
          .pdm-doc-name {
            font-size: 14px;
            font-weight: 500;
            color: #2563eb;
            background: none;
            border: none;
            padding: 0;
            cursor: pointer;
            display: flex;
            align-items: center;
            gap: 6px;
            text-align: left;
            line-height: 1.3;
            transition: color 0.15s;
          }
          .pdm-doc-name:hover { color: var(--c-indigo-h); text-decoration: underline; }
          .pdm-doc-name-wrapper {
            display: inline-flex;
            align-items: center;
            gap: 6px;
            max-width: 100%;
          }
          .pdm-doc-copy-btn {
            background: none;
            border: none;
            padding: 2px 4px;
            cursor: pointer;
            color: #94a3b8;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            font-size: 12px;
            transition: opacity 0.15s ease, color 0.15s ease, background-color 0.15s ease, transform 0.1s ease;
            border-radius: 0;
            opacity: 0;
          }
          .pdm-doc-row:hover .pdm-doc-name-wrapper .pdm-doc-copy-btn,
          .pdm-doc-name-wrapper:hover .pdm-doc-copy-btn,
          .pdm-doc-copy-btn:focus {
            opacity: 1;
          }
          .pdm-doc-copy-btn:hover {
            color: #2563eb;
            background: #eff6ff;
            transform: scale(1.08);
          }
          .pdm-doc-copy-btn:active {
            transform: scale(0.95);
          }
          .pdm-doc-meta {
            display: flex;
            align-items: center;
            gap: 10px;
            margin-top: 4px;
            flex-wrap: wrap;
          }
          .pdm-doc-date {
            font-size: 11px !important;
            font-weight: 400 !important;
            color: #64748b !important;
            display: inline-flex !important;
            align-items: center !important;
            gap: 4px !important;
          }
          .pdm-doc-size {
            font-size: 11px !important;
            font-weight: 400 !important;
            color: #64748b !important;
            display: inline-flex !important;
            align-items: center !important;
            gap: 3px !important;
          }
          .pdm-doc-date i,
          .pdm-doc-size i {
            display: none !important;
          }
          .pdm-doc-type-tag {
            font-size: 12px;
            font-weight: 600;
            color: #64748b;
            background: var(--c-surface);
            border: 1px solid var(--c-border);
            border-radius: 0;
            padding: 1px 7px;
          }
          .pdm-doc-uploader {
            font-size: 11px !important;
            color: #64748b !important;
            font-weight: 400 !important;
            display: inline-flex !important;
            align-items: center !important;
            gap: 4px !important;
          }
          .pdm-doc-uploader i {
            display: none !important;
          }

          .pdm-col-center { display: flex; align-items: center; justify-content: center; }
          .pdm-col-right { display: flex; align-items: center; justify-content: flex-end; gap: 6px; flex-wrap: wrap; }

          /* â”€â”€ Status badges â”€â”€ */
          .pdm-badge {
            display: inline-flex;
            align-items: center;
            gap: 4px;
            padding: 4px 10px;
            border-radius: 0;
            font-size: 12px;
            font-weight: 600;
            white-space: nowrap;
          }
          /* Sizing matches the stacked variant so a Sent badge looks the same
             whether or not it sits above a sent-date. */
          .pdm-badge-sent    { background: rgba(37, 99, 235, 0.08); color: #1d4ed8; border: 1px solid rgba(37, 99, 235, 0.15); padding: 5px 12px; font-weight: 600; }
          .pdm-badge-esign   { background: rgba(37, 99, 235, 0.08); color: #1d4ed8; border: 1px solid rgba(37, 99, 235, 0.15); }
          .pdm-badge-done    { background: rgba(16, 185, 129, 0.08);  color: #047857; border: 1px solid rgba(16, 185, 129, 0.15); }
          .pdm-badge-pending { background: rgba(245, 158, 11, 0.1);  color: #b45309; border: 1px solid rgba(245, 158, 11, 0.2); }
          .pdm-badge-na      { background: #f8fafc;  color: #64748b; border: 1px solid #e2e8f0; }
          .pdm-badge-deleted { background: rgba(239, 68, 68, 0.06);   color: #dc2626; border: 1px solid rgba(239, 68, 68, 0.18); }

          /* â”€â”€ Table header â”€â”€ */
          .pdm-list-header {
            display: grid;
            align-items: center;
            gap: 12px;
            padding: 8px 16px;
            font-size: 12px;
            font-weight: 600;
            text-transform: uppercase;
            letter-spacing: 0.07em;
            color: #64748b;
            margin-bottom: 6px;
          }

          /* â”€â”€ Empty state â”€â”€ */
          .pdm-empty {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            padding: 60px 24px;
            text-align: center;
            color: var(--c-text-3);
            background: #ffffff;
            border: 1px dashed #cbd5e1;
            border-radius: 0;
          }
          .pdm-empty-icon {
            width: 52px;
            height: 52px;
            border-radius: 0;
            background: var(--c-surface);
            border: 1px solid var(--c-border);
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 22px;
            margin-bottom: 14px;
            color: var(--c-text-3);
          }
          .pdm-empty h5 {
            font-size: 14px;
            font-weight: 500;
            color: #1e293b;
            margin: 0 0 6px;
          }
          .pdm-empty p {
            font-size: 14px;
            font-weight: 400;
            margin: 0;
          }

          /* â”€â”€ Section divider â”€â”€ */
          .pdm-section-label {
            display: flex;
            align-items: center;
            gap: 8px;
            font-size: 12px;
            font-weight: 600;
            text-transform: uppercase;
            letter-spacing: 0.06em;
            color: #64748b;
            margin: 22px 0 12px;
          }
          .pdm-tab-body > .pdm-section-label:first-child {
            margin-top: 8px;
          }
          .pdm-section-label::after {
            content: '';
            flex: 1;
            height: 1px;
            background: var(--c-border-light);
          }

          /* â”€â”€ History grid â”€â”€ */
          .pdm-history-grid {
            display: grid;
            grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
            gap: 16px;
          }
          .pdm-history-card {
            background: var(--c-bg);
            border: 1px solid var(--c-border);
            border-radius: 0;
            overflow: hidden;
          }
          .pdm-history-card-head {
            background: var(--c-surface);
            border-bottom: 1px solid var(--c-border-light);
            padding: 12px 16px;
            display: flex;
            align-items: center;
            gap: 8px;
            font-size: 14px;
            font-weight: 500;
            color: #1e293b;
          }
          .pdm-history-card-head i { display: none !important; }
          .pdm-history-card-body { padding: 12px 16px; }
          .pdm-history-doc-item {
            display: flex;
            flex-direction: column;
            gap: 2px;
            padding: 8px 0;
            border-bottom: 1px dashed var(--c-border-light);
          }
          .pdm-history-doc-item:last-child { border-bottom: none; padding-bottom: 0; }
          .pdm-history-doc-item-icon { display: none !important; }
          .pdm-history-doc-name {
            font-size: 14px;
            font-weight: 500;
            color: var(--c-indigo);
            background: none;
            border: none;
            padding: 0;
            cursor: pointer;
            text-align: left;
            line-height: 1.3;
            transition: color 0.15s;
          }
          .pdm-history-doc-name:hover { color: var(--c-indigo-h); text-decoration: underline; }
          .pdm-history-doc-date {
            font-size: 11px !important;
            font-weight: 400 !important;
            color: #64748b !important;
            margin-top: 2px !important;
            display: block !important;
          }
          .pdm-history-doc-date i {
            display: none !important;
          }

          /* â”€â”€ Received status select â”€â”€ */
          .pdm-select {
            font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
            font-size: 14px;
            font-weight: 400;
            padding: 6px 10px;
            border-radius: 0;
            border: 1px solid var(--c-border);
            background: var(--c-bg);
            color: #1e293b;
            cursor: pointer;
            outline: none;
            transition: border-color 0.15s;
            min-width: 130px;
          }
          .pdm-select:focus { border-color: var(--c-indigo); }

          /* ── Copy flash ── */
          .pdm-copied {
            font-size: 12px;
            font-weight: 600;
            color: var(--c-green);
            background: var(--c-green-s);
            border-radius: 0;
            padding: 2px 8px;
          }

          /* ── Popover ── */
          .popover {
            border-radius: 0 !important;
            border: 1px solid #cbd5e1 !important;
            box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05) !important;
            font-family: "Open Sans", sans-serif !important;
            overflow: hidden;
            z-index: 9999 !important;
          }
          .popover-header, .popover-title {
            background: #f8fafc !important;
            border-bottom: 1px solid #e2e8f0 !important;
            font-size: 14px !important;
            font-weight: 500 !important;
            color: #1e293b !important;
            padding: 10px 14px !important;
          }
          .popover-body, .popover-content {
            padding: 12px 14px !important;
            font-size: 14px !important;
            font-weight: 400 !important;
            color: #1e293b !important;
            line-height: 1.55 !important;
          }

          /* ── Dropdown ── */
          .pdm-root .dropdown { display: inline-block !important; }
          .pdm-root .dropdown-toggle {
            display: inline-flex !important;
            align-items: center !important;
            gap: 6px !important;
            font-size: 14px !important;
            font-weight: 500 !important;
            padding: 8px 12px !important;
            border-radius: 0 !important;
            border: 1px solid var(--c-border) !important;
            background: var(--c-bg) !important;
            color: var(--c-text-2) !important;
            cursor: pointer !important;
            transition: all 0.15s ease !important;
          }
          .pdm-root .dropdown-toggle:hover { background: var(--c-surface) !important; color: var(--c-text) !important; }
          .pdm-root .dropdown-menu {
            border-radius: 0 !important;
            border: 1px solid var(--c-border) !important;
            box-shadow: var(--sh-lg) !important;
            padding: 6px !important;
            background: var(--c-bg) !important;
            min-width: 200px !important;
            z-index: 1050 !important;
          }
          .pdm-root .dropdown-item {
            border-radius: 0 !important;
            padding: 9px 14px !important;
            font-size: 14px !important;
            color: #1e293b !important;
            font-weight: 500 !important;
            font-family: "Open Sans", sans-serif !important;
            transition: all 0.13s !important;
            display: flex !important;
            align-items: center !important;
            gap: 8px !important;
          }
          .pdm-root .dropdown-item i,
          .pdm-root .dropdown-item span,
          .pdm-root .dropdown-item a {
            color: inherit !important;
          }
          .pdm-root .dropdown-item:hover,
          .pdm-root .dropdown-item:focus,
          .pdm-root .dropdown-item:active {
            background: #f8fafc !important;
            color: #0f172a !important;
          }
          .pdm-root .dropdown-item.text-danger,
          .pdm-root .dropdown-item.is-danger {
            color: #dc2626 !important;
          }
          .pdm-root .dropdown-item.text-danger:hover,
          .pdm-root .dropdown-item.is-danger:hover {
            background: #fef2f2 !important;
            color: #b91c1c !important;
          }
          .pdm-root .dropdown-item:disabled, .pdm-root .dropdown-item[disabled] { opacity: 0.4 !important; pointer-events: none !important; }

          /* â”€â”€ Tab panel border â”€â”€ */
          .pdm-root .tab-pane.p-3.border,
          .pdm-root .p-3.border {
            padding: 0 !important;
            border: none !important;
          }

          .pdm-root-embedded {
            background: #ffffff;
            border: none;
            border-radius: 0;
            box-shadow: none;
            overflow: visible;
          }
          .pdm-root-embedded .pdm-header {
            justify-content: flex-end;
            padding: 0 0 14px;
            background: #ffffff;
            border-bottom: none;
          }
          .pdm-root-embedded .pdm-header-actions {
            justify-content: flex-end;
          }
          .pdm-root-embedded .pdm-summary-grid {
            padding: 0 0 16px;
            border-bottom: 1px solid var(--c-border-light);
          }
          .pdm-root-embedded .pdm-tabs-wrap {
            padding: 16px 0 0;
          }
          .pdm-root-embedded .pdm-tab-body {
            padding: 20px 0 0;
          }

          @media (max-width: 1100px) {
            .pdm-summary-grid {
              grid-template-columns: repeat(3, minmax(130px, 1fr));
            }
          }

          @media (max-width: 768px) {
            .pdm-header,
            .pdm-summary-grid,
            .pdm-tabs-wrap {
              padding-left: 16px;
              padding-right: 16px;
            }
            .pdm-header-actions {
              width: 100%;
              justify-content: flex-start;
            }
            .pdm-root-embedded .pdm-header,
            .pdm-root-embedded .pdm-summary-grid,
            .pdm-root-embedded .pdm-tabs-wrap,
            .pdm-root-embedded .pdm-tab-body {
              padding-left: 0;
              padding-right: 0;
            }
            .pdm-summary-grid {
              grid-template-columns: repeat(2, minmax(0, 1fr));
            }
            .custom-tabs-list {
              width: 100% !important;
              overflow-x: auto !important;
              flex-wrap: nowrap !important;
              padding: 4px !important;
            }
            .pdm-doc-row,
            .pdm-list-header {
              grid-template-columns: 1fr !important;
            }
            .pdm-list-header {
              display: none;
            }
            .pdm-col-center,
            .pdm-col-right {
              justify-content: flex-start;
            }
            .pdm-doc-file {
              width: 100%;
            }
            .pdm-doc-actions-panel {
              display: flex;
              min-width: 0;
              justify-content: flex-start;
              justify-items: start;
            }
            .pdm-doc-status-stack {
              align-items: flex-start;
              justify-content: flex-start;
            }
            .pdm-doc-status-date {
              position: static;
              transform: none;
              width: auto;
            }
            .pdm-doc-actions-divider {
              display: none;
            }
          }

          @media (max-width: 520px) {
            .pdm-summary-grid {
              grid-template-columns: 1fr;
            }
            .pdm-title {
              font-size: 18px;
            }
            .pdm-btn,
            .pdm-root .dropdown,
            .pdm-root .dropdown-toggle {
              width: 100%;
              justify-content: center !important;
            }
          }

          /* Neutral application theme; document names remain recognizable links. */
          .pdm-root:not(.pdm-root-embedded) {
            border-color: #d1d5db !important;
            box-shadow: none !important;
          }
          .pdm-root .pdm-summary-grid,
          .pdm-root .pdm-tabs-wrap,
          .pdm-root .pdm-tab-body {
            background: #ffffff !important;
          }
          .pdm-root .pdm-stat-card {
            border-color: #d1d5db !important;
            box-shadow: none !important;
          }
          .pdm-root .pdm-stat-icon,
          .pdm-root .pdm-stat-icon.is-green,
          .pdm-root .pdm-stat-icon.is-amber,
          .pdm-root .pdm-stat-icon.is-rose,
          .pdm-root .pdm-stat-icon.is-sky {
            background: #f3f4f6 !important;
            color: #737373 !important;
          }
          .pdm-root .custom-tabs-list {
            background: #f5f5f5 !important;
            border-color: #d1d5db !important;
            box-shadow: none !important;
          }
          .pdm-root .custom-tab-item {
            color: #64748b !important;
            font-weight: 500 !important;
            box-shadow: none !important;
          }
          .pdm-root .custom-tab-item:hover {
            background: #ffffff !important;
            color: #1e293b !important;
          }
          .pdm-root .custom-tab-item.active,
          .pdm-root .custom-tab-item.active:hover {
            background: #171717 !important;
            border-color: #171717 !important;
            color: #ffffff !important;
            box-shadow: none !important;
          }
          .pdm-root .custom-tab-item > i {
            color: #94a3b8 !important;
          }
          .pdm-root .custom-tab-item.active i,
          .pdm-root .custom-tab-item.active:hover i,
          .pdm-root .custom-tab-item.active svg,
          .pdm-root .custom-tab-item.active:hover svg {
            color: #ffffff !important;
            fill: #ffffff !important;
            background: #171717 !important;
            border-color: #171717 !important;
            box-shadow: none !important;
            opacity: 1 !important;
          }
          .pdm-root .custom-tab-item.active svg path,
          .pdm-root .custom-tab-item.active:hover svg path {
            fill: #ffffff !important;
          }
          .pdm-root .custom-tab-item.active .tab-count,
          .pdm-root .custom-tab-item.active:hover .tab-count {
            background: #ffffff !important;
            border-color: #ffffff !important;
            color: #1e293b !important;
            font-weight: 500 !important;
            box-shadow: none !important;
          }
          .pdm-root .pdm-doc-row,
          .pdm-root .pdm-doc-row-card {
            background: #ffffff !important;
            border: none !important;
            border-bottom: 1px solid #e2e8f0 !important;
            border-radius: 0 !important;
            box-shadow: none !important;
          }
          .pdm-root .pdm-doc-row:hover,
          .pdm-root .pdm-doc-row-card:hover {
            background: #f8fafc !important;
            border: none !important;
            border-bottom: 1px solid #cbd5e1 !important;
            box-shadow: none !important;
            transform: none !important;
          }
          .pdm-root .pdm-doc-file-icon {
            background: #f3f4f6 !important;
            border: 1px solid #d1d5db !important;
            color: #737373 !important;
            box-shadow: none !important;
          }
          .pdm-root .pdm-btn,
          .pdm-root .pdm-btn-primary,
          .pdm-root .pdm-btn-secondary,
          .pdm-root .pdm-btn-ghost,
          .pdm-root .pdm-btn-ghost-violet,
          .pdm-root .pdm-btn-ghost-indigo,
          .pdm-root .pdm-btn-ghost-sky,
          .pdm-root .pdm-btn-sm,
          .pdm-root .dropdown-toggle,
          .pdm-root button.btn,
          .pdm-root button.btn-sm,
          .pdm-root .btn-action-search {
            background: #ffffff !important;
            border: 1px solid #cbd5e1 !important;
            color: #1e293b !important;
            font-size: 14px !important;
            font-weight: 500 !important;
            font-family: "Open Sans", sans-serif !important;
            box-shadow: 0 2px 5px rgba(15, 23, 42, 0.08) !important;
            height: 34px !important;
            min-height: 34px !important;
            padding: 0 14px !important;
            border-radius: 0 !important;
            transform: none !important;
            display: inline-flex !important;
            align-items: center !important;
            justify-content: center !important;
            gap: 7px !important;
            line-height: 1.25 !important;
            text-decoration: none !important;
          }
          .pdm-root .pdm-btn:hover,
          .pdm-root .pdm-btn-primary:hover,
          .pdm-root .pdm-btn-secondary:hover,
          .pdm-root .pdm-btn-ghost:hover,
          .pdm-root .pdm-btn-ghost-violet:hover,
          .pdm-root .pdm-btn-ghost-indigo:hover,
          .pdm-root .pdm-btn-ghost-sky:hover,
          .pdm-root .pdm-btn-sm:hover,
          .pdm-root .dropdown-toggle:hover,
          .pdm-root button.btn:hover,
          .pdm-root button.btn-sm:hover,
          .pdm-root .btn-action-search:hover {
            background: #f8fafc !important;
            border-color: #94a3b8 !important;
            color: #0f172a !important;
            box-shadow: 0 3px 8px rgba(15, 23, 42, 0.12) !important;
            transform: none !important;
          }
          .pdm-root .pdm-btn-ghost-danger {
            background: #ffffff !important;
            border: 1px solid #fca5a5 !important;
            color: #dc2626 !important;
            font-size: 14px !important;
            font-weight: 500 !important;
            font-family: "Open Sans", sans-serif !important;
            box-shadow: 0 2px 5px rgba(15, 23, 42, 0.08) !important;
            height: 34px !important;
            min-height: 34px !important;
            padding: 0 14px !important;
            border-radius: 0 !important;
            transform: none !important;
            display: inline-flex !important;
            align-items: center !important;
            justify-content: center !important;
            gap: 7px !important;
            line-height: 1.25 !important;
          }
          .pdm-root .pdm-btn-ghost-danger:hover {
            background: #fef2f2 !important;
            border-color: #ef4444 !important;
            color: #b91c1c !important;
            box-shadow: 0 3px 8px rgba(15, 23, 42, 0.12) !important;
            transform: none !important;
          }
          .pdm-root .pdm-btn i,
          .pdm-root .dropdown-toggle i,
          .pdm-root button i {
            color: inherit !important;
          }
          .pdm-root .pdm-doc-name,
          .pdm-root .pdm-history-doc-name {
            color: #2563eb !important;
            font-weight: 500 !important;
            text-decoration: none !important;
          }
          .pdm-root .pdm-doc-name:hover,
          .pdm-root .pdm-history-doc-name:hover {
            color: #1d4ed8 !important;
            font-weight: 500 !important;
            text-decoration: none !important;
          }
          .pdm-root .pdm-not-received-text,
          .pdm-root .pdm-plain-status-text {
            color: #64748b !important;
            font-size: 14px !important;
            font-weight: 400 !important;
            background: transparent !important;
            border: none !important;
            padding: 0 !important;
          }
          .pdm-root .pdm-doc-actions-panel .pdm-badge {
            color: #64748b !important;
            font-size: 14px !important;
            font-weight: 400 !important;
            line-height: 1.3 !important;
            background: transparent !important;
            border: none !important;
            border-radius: 0 !important;
            padding: 0 !important;
            box-shadow: none !important;
          }
          .pdm-root .pdm-doc-actions-panel .pdm-badge i {
            display: none !important;
          }

          .pdm-root,
          .pdm-root *,
          .pdm-root *::before,
          .pdm-root *::after,
          .pdm-root .pdm-btn,
          .pdm-root .pdm-badge,
          .pdm-root .pdm-meta-pill,
          .pdm-root .pdm-stat-card,
          .pdm-root .pdm-stat-icon,
          .pdm-root .custom-tabs-list,
          .pdm-root .custom-tab-item,
          .pdm-root .tab-count,
          .pdm-root .pdm-doc-row,
          .pdm-root .pdm-doc-row-card,
          .pdm-root .pdm-doc-file-icon,
          .pdm-root .pdm-doc-mini-badge,
          .pdm-root .pdm-doc-esign-tag,
          .pdm-root .pdm-doc-type-tag,
          .pdm-root .pdm-doc-copy-btn,
          .pdm-root .pdm-empty,
          .pdm-root .pdm-empty-icon,
          .pdm-root .pdm-history-card,
          .pdm-root .pdm-history-doc-item-icon,
          .pdm-root .pdm-select,
          .pdm-root .popover,
          .pdm-root .dropdown-toggle,
          .pdm-root .dropdown-menu,
          .pdm-root .dropdown-item {
            border-radius: 0 !important;
            -webkit-border-radius: 0 !important;
            -moz-border-radius: 0 !important;
          }
        `}} />

        {/* PAGE HEADER */}
        <div className="pdm-header">
          {!embedded && (
            <div className="pdm-header-left">
              <div className="pdm-icon-box">
                <i className="fa fa-file-text-o" />
              </div>
              <div className="pdm-title-block">
                <p className="pdm-title">{getDynamicTabTitle(uploadType)}</p>
                <div className="pdm-header-meta">
                  <span className="pdm-meta-pill meta-id">
                    <i className="fa fa-id-badge" /> ID: {applicantObj?.performerid || applicantObj?.fuid || "New"}
                  </span>
                  {(applicantObj?.label || applicantObj?.performername || applicantObj?.name) && (
                    <span className="pdm-meta-pill meta-person">
                      <i className="fa fa-user" /> {applicantObj?.label || applicantObj?.performername || applicantObj?.name || applicantObj?.subcontractor?.name || applicantObj?.recruiter?.name}
                    </span>
                  )}
                  {(applicantObj?.email || applicantObj?.performeremail) && (
                    <span className="pdm-meta-pill meta-email">
                      <i className="fa fa-envelope-o" /> {applicantObj?.email || applicantObj?.performeremail}
                    </span>
                  )}
                  <span className={`pdm-meta-pill ${documentStatusClass}`}>
                    <i className="fa fa-info-circle" /> Status: {documentStatusLabel}
                  </span>
                  {wfTask?.ciid && (
                    <span className="pdm-meta-pill meta-ciid">
                      <i className="fa fa-hashtag" /> CIID {wfTask.ciid}
                    </span>
                  )}
                </div>
              </div>
            </div>
          )}
          <div className="pdm-header-actions">
            {typeof onBack === "function" && (
              <button className="pdm-btn" onClick={onBack}>
                <i className="fa fa-arrow-left" /> Back
              </button>
            )}
            <button className="pdm-btn" onClick={handleDocumentLoad}>
              <i className="fa fa-refresh" /> Refresh
            </button>
            {hasContractDocuments && currentFlowType && (
              <button
                type="button"
                className="pdm-btn"
                onClick={() => setViewOverride(viewOverride === "default" ? "current" : "default")}
                title={viewOverride === "default" ? "View document tabs" : "View default documents checklist"}
              >
                <i className={`fa ${viewOverride === "default" ? "fa-folder-open-o" : "fa-list-alt"}`} />{" "}
                {viewOverride === "default" ? "Document Tabs" : "Default Documents"}
              </button>
            )}
            {!(uploadType === "Recruiter" && viewType === "candidateList") && (
              <div className="dropdown">
                <button
                  className="pdm-btn dropdown-toggle"
                  type="button"
                  id="docUploadDropdown"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <i className="fa fa-plus" /> Add Document
                </button>
                <div className="dropdown-menu dropdown-menu-right" aria-labelledby="docUploadDropdown">
                  {/* Candidate-list subcontractor actions use the SubCan default-document flow. */}
                  {viewType === "candidateList" && uploadType === "Subcontractor" ? (
                    <>
                      <button
                        type="button"
                        className="dropdown-item"
                        onClick={() => setOtherDocShowHide("other")}
                      >
                        <i className="fa fa-folder-open" /> Upload Other Document
                      </button>
                      {/* <button
                        type="button"
                        className="dropdown-item"
                        onClick={handleLoadDefaultC2CDocuments}
                      >
                        <i className="fa fa-download" /> Load Default Documents
                      </button> */}
                    </>
                  ) : (
                    <>
                      {uploadType !== "agency" && uploadType !== "msp" && (
                        <>
                          <button
                            type="button"
                            className="dropdown-item"
                            onClick={() => handleContractShowHide()}
                            disabled={viewType === "candidateList" && (uploadType === "Subcontractor" || uploadType === "Recruiter")}
                          >
                            <i className="fa fa-magic" /> Generate Documents
                          </button>
                          <button
                            type="button"
                            className="dropdown-item"
                            onClick={() => handleDocShowHide("repository")}
                            disabled={viewType === "candidateList" && (uploadType === "Subcontractor" || uploadType === "Recruiter")}
                          >
                            <i className="fa fa-database" /> Upload from DDRMS Repository
                          </button>
                          <button
                            type="button"
                            className="dropdown-item"
                            onClick={() => setOtherDocShowHide("other")}
                            disabled={viewType === "candidateList" && (uploadType === "Recruiter" || type === "candetails")}
                          >
                            <i className="fa fa-folder-open" /> Upload Other Document
                          </button>
                          {/* {(app?.applicationType === "C2C Candidate Onboarding" || app?.applicationType === "W2 Candidate Onboarding" || app?.applicationType === "1099 Candidate Onboarding" || app?.applicationType === "Subcontractor Application" || app?.applicationType === "Recruiter Application" || (viewType === "candidateList" && uploadType === "Subcontractor")) && (
                            <button
                              type="button"
                              className="dropdown-item"
                              onClick={handleLoadDefaultC2CDocuments}
                              disabled={viewType === "candidateList" && (uploadType === "Subcontractor" || uploadType === "Recruiter")}
                            >
                              <i className="fa fa-download" /> Load Default Documents
                            </button>
                          )} */}
                        </>
                      )}
                      <button
                        type="button"
                        className="dropdown-item"
                        onClick={() => handleDocShowHide("upload")}
                        disabled={viewType === "candidateList" && (uploadType === "Subcontractor" || uploadType === "Recruiter")}
                      >
                        <i className="fa fa-upload" /> Upload from Local Drive
                      </button>
                    </>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>



        {/* Document Body: Loading, Default Documents section, or Current Documents Tabs */}
        {isDocumentsLoading && !hasFetchedForCiid ? (
          <div
            className="pdm-loading-placeholder"
            style={{
              padding: "60px 20px",
              textAlign: "center",
              background: "#ffffff",
              border: "1px solid #e2e8f0",
              margin: "12px 0"
            }}
          >
            <i className="fa fa-circle-o-notch fa-spin fa-2x" style={{ color: "#2563eb", marginBottom: 12 }} />
            <p style={{ color: "#64748b", fontSize: "14px", margin: 0, fontWeight: 500 }}>
              Loading contract documents...
            </p>
          </div>
        ) : ((!hasContractDocuments && currentFlowType && defaultC2CDocuments.length > 0) || (currentFlowType && viewOverride === "default")) ? (
          <div className="pdm-embedded-default-docs" style={{ marginTop: 12 }}>
            {renderDefaultDocuments(true, pendingDefaultDocuments)}
          </div>
        ) : (
          <div className="pdm-tabs-wrap">
            <CustomTabs defaultActiveKey={defaultActiveKey} id="pdm-tabs">

              {/* UPLOAD tab */}
              <CustomTab
                eventKey={2}
                title={
                  <span>
                    <i className="fa fa-cloud-upload mr-1" />
                    Documents
                    <span className="tab-count ml-2">
                      {uploadType === "agency" || uploadType === "msp"
                        ? sentAgencyMapDocuments.filter(x => x.uploadType !== "client" && x.uploadType !== "reporting" && x.uploadType !== "project" && x.uploadType !== "candidate" && x.uploadType !== "ProjectInfo" && x.updType !== "internal").length
                        : visibleDocumentRows.length}
                    </span>
                  </span>
                }
                className=""
              >
                <div className="pdm-tab-body">
                  {/* Upload tab document list */}
                  {(uploadType === "agency" || uploadType === "msp") ? (
                    <>
                      {(() => {
                        const docs = sentAgencyMapDocuments.filter(x =>
                          x.uploadType !== "client" && x.uploadType !== "reporting" && x.uploadType !== "project" && x.uploadType !== "candidate" && x.uploadType !== "ProjectInfo" && x.updType !== "internal"
                        );
                        if (docs.length === 0) return (
                          <div className="pdm-empty">
                            <div className="pdm-empty-icon"><i className="fa fa-file-o" /></div>
                            <h5>No documents yet</h5>
                            <p>Use "Add Document" above to upload your first file.</p>
                          </div>
                        );
                        return (
                          <>
                            <div className="pdm-list-header pdm-doc-row-upload" style={{ gridTemplateColumns: '1fr auto auto' }}>
                              <span>Document</span>
                              <span>Size</span>
                              <span>Sent</span>
                            </div>
                            <div className="pdm-doc-list">
                              {docs.map((item, key) => (
                                <div key={key} className="pdm-doc-row" style={{ gridTemplateColumns: '1fr auto auto' }}>
                                  <div className="pdm-doc-info">
                                    <span className="pdm-doc-name-wrapper">
                                      <button className="pdm-doc-name" onClick={() => handleDownloadFile(item)}>
                                        <i className={`fa ${getDocumentIcon(item)}`} /> {item.docName}
                                      </button>
                                      <button
                                        className="pdm-doc-copy-btn"
                                        title="Copy shareable link"
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          handleCopyClipboard(`/DownloadDocLink/${item.docId}`);
                                        }}
                                      >
                                        {copyItem === `${window.location.origin}/DownloadDocLink/${item.docId}` ? (
                                          <i className="fa fa-check" style={{ color: 'var(--c-green)' }} />
                                        ) : (
                                          <i className="fa fa-copy" />
                                        )}
                                      </button>
                                    </span>
                                    <div className="pdm-doc-meta">
                                      <span className="pdm-doc-date"><Moment format="MMM Do YYYY, h:mm a">{item.dateTime}</Moment></span>
                                    </div>
                                  </div>
                                  <div className="pdm-col-center"><span className="pdm-doc-size">{item.docSize}</span></div>
                                  <div className="pdm-col-center">
                                    {item.sentStatus
                                      ? <span className="pdm-badge pdm-badge-sent"><i className="fa fa-check" /> Sent</span>
                                      : <button
                                        className="pdm-btn pdm-btn-sm pdm-btn-ghost-danger"
                                        onClick={() => handleDeleteDocument(item.docId)}
                                        style={{ width: '38px', padding: 0, justifyContent: 'center' }}
                                        title="Delete"
                                      >
                                        <i className="fa fa-trash" />
                                      </button>
                                    }
                                  </div>
                                </div>
                              ))}
                            </div>
                          </>
                        );
                      })()}
                    </>
                  ) : (
                    <>
                      {visibleDocumentRows.length === 0 ? (
                        currentFlowType ? (
                          <div className="pdm-default-docs-embedded" style={{ marginTop: 8 }}>
                            {renderDefaultDocuments(true, pendingDefaultDocuments)}
                          </div>
                        ) : (
                          <div className="pdm-empty">
                            <div className="pdm-empty-icon"><i className="fa fa-file-o" /></div>
                            <h5>No documents yet</h5>
                            <p>Use "Add Document" above to upload your first file.</p>
                          </div>
                        )
                      ) : (
                        <>
                          {/* Sent documents */}
                          {sortMergedDocs.some(d => d.__docType === "sent") && (
                            <>
                              <div className="pdm-section-label"><i className="fa fa-paper-plane" /> Uploaded Documents</div>
                              <div className="pdm-doc-list">
                                {sortMergedDocs.filter(d => d.__docType === "sent").map((item, key) => {
                                  const itemDocData = String(item?.docData ?? "").trim();
                                  const itemDocId = Number(item?.docId || item?.id || 0);
                                  const itemEvelopId = String(item?.evelopId || item?.EvelopId || "").trim();

                                  const matchingESignDoc = esignDocuments.find((doc) => {
                                    const esignEvelopId = String(doc?.evelopId || doc?.EvelopId || doc?.id || "").trim();
                                    // 1. Direct match by envelope ID if item already has evelopId
                                    if (itemEvelopId && esignEvelopId && itemEvelopId === esignEvelopId) {
                                      return true;
                                    }

                                    // 2. Direct match by docId (source document ID)
                                    const esignDocId = Number(doc?.docId || doc?.documentId || doc?.DocumentId || doc?.sourceDocumentId || 0);
                                    if (itemDocId > 0 && esignDocId > 0) {
                                      return esignDocId === itemDocId;
                                    }

                                    // 3. Fallback for non-repository docs only when docId is not available on either
                                    // (Repository/DDRMS documents must NEVER match by generic template ID docData)
                                    if (!item?.isRepositoryDoc && itemDocData !== "") {
                                      const esignDocData = String(doc?.docData ?? "").trim();
                                      if (esignDocData === itemDocData && esignDocId === 0 && itemDocId === 0) {
                                        return true;
                                      }
                                    }

                                    return false;
                                  }) || (item?.signedStatus !== null && item?.signedStatus !== undefined ? item : null);

                                  const evelopId = itemEvelopId || (matchingESignDoc && matchingESignDoc !== item ? (matchingESignDoc.evelopId || matchingESignDoc.EvelopId || null) : null);
                                  const esignBaseUrl = getEsignBaseUrl();
                                  const esignApiBaseUrl = getEsignApiBaseUrl();
                                  const signedStatusValue = String(matchingESignDoc?.signedStatus ?? "");
                                  const hasSignedDownloadOptions = signedStatusValue === "0" || signedStatusValue === "1";
                                  const esignSigned = isESignDocumentSigned(matchingESignDoc?.signedStatus);
                                  // The logged-in workbench user's own signer status. They may have
                                  // signed while other signers are still pending (Partially Signed).
                                  const currentUserSigned = isESignDocumentSigned(matchingESignDoc?.currentUserSignStatus);
                                  // The logged-in user is only a signer on this document when a signer
                                  // status came back for them. Only an assigned signer who has not yet
                                  // signed or rejected should see the Sign button - otherwise clicking
                                  // it would open another signer's link.
                                  const currentUserSignStatusNorm = String(matchingESignDoc?.currentUserSignStatus || "").replace(/\s+/g, "").toLowerCase();
                                  const currentUserCanSign = !!currentUserSignStatusNorm
                                    && currentUserSignStatusNorm !== "signed"
                                    && currentUserSignStatusNorm !== "completed"
                                    && currentUserSignStatusNorm !== "rejected";

                                  const isDocumentSent = item.sentStatus || (matchingESignDoc && matchingESignDoc.sendStatus);

                                  const links = docEsignLinks[item.docId] || {};
                                  const prepareUrl = links.prepare || `${esignBaseUrl}/prepare/${evelopId}`;
                                  const detailsUrl = links.details || `${esignBaseUrl}/documents/${evelopId}/details`;
                                  const logsUrl = links.logs || `${esignBaseUrl}/documents/${evelopId}/logs`;
                                  const visibleSignedUrl = links.visibleSigned || `${esignApiBaseUrl}/api/public/documents/${evelopId}/download/visible-signed?inline=true`;
                                  const finalSignedUrl = links.finalSigned || `${esignApiBaseUrl}/api/public/documents/${evelopId}/download/final-signed?inline=true`;

                                  const sentDate = item.sentDateTime || matchingESignDoc?.createdDateTime;

                                  const getESignBadgeDetails = (signedStatus, evId, isSent) => {
                                    if (!evId) return null;
                                    let status = signedStatus;
                                    if (!status) {
                                      status = isSent ? "Sent" : "Draft";
                                    }
                                    switch (String(status)) {
                                      case "0":
                                        return { text: "Partially Signed", icon: "fa-adjust", className: "pdm-badge-pending" };
                                      case "1":
                                        return { text: "Signed", icon: "fa-check-circle", className: "pdm-badge-done" };
                                      case "Draft":
                                        return { text: "Draft", icon: "fa-pencil-square-o", className: "pdm-badge-esign" };
                                      case "Sent":
                                        return { text: "Sent", icon: "fa-check", className: "pdm-badge-sent" };
                                      case "Partially Signed":
                                      case "PartiallySigned":
                                        return { text: "Partially Signed", icon: "fa-adjust", className: "pdm-badge-pending" };
                                      case "Signed":
                                      case "Completed":
                                        return { text: "Signed", icon: "fa-check-circle", className: "pdm-badge-done" };
                                      case "Expired":
                                        return { text: "Expired", icon: "fa-times-circle", className: "pdm-badge-deleted" };
                                      case "Cancelled":
                                      case "Canceled":
                                        return { text: "Cancelled", icon: "fa-ban", className: "pdm-badge-deleted" };
                                      case "Rejected":
                                        return { text: "Rejected", icon: "fa-minus-circle", className: "pdm-badge-deleted" };
                                      default:
                                        return { text: status, icon: "fa-info-circle", className: "pdm-badge-sent" };
                                    }
                                  };

                                  return (
                                    <div key={`sent-${key}`} className="pdm-doc-row pdm-doc-row-card">
                                      {/* Doc info */}
                                      <div className="pdm-doc-file">
                                        <span className="pdm-doc-file-icon"><i className={`fa ${getDocumentIcon(item)}`} /></span>
                                        <div className="pdm-doc-file-main">
                                          <span className="pdm-doc-name-wrapper">
                                            <button className="pdm-doc-name" onClick={() => handleDownloadFile(item)}>
                                              {item.docId} - {item.docName}
                                            </button>
                                            <button
                                              className="pdm-doc-copy-btn"
                                              title="Copy shareable link"
                                              onClick={(e) => {
                                                e.stopPropagation();
                                                handleCopyClipboard(`/DownloadDocLink/${item.docId}`);
                                              }}
                                            >
                                              {copyItem === `${window.location.origin}/DownloadDocLink/${item.docId}` ? (
                                                <i className="fa fa-check" style={{ color: 'var(--c-green)' }} />
                                              ) : (
                                                <i className="fa fa-copy" />
                                              )}
                                            </button>
                                          </span>
                                          <div className="pdm-doc-meta">
                                            <span className="pdm-doc-date"><Moment format="MMM Do YYYY">{item.dateTime}</Moment> | <Moment format="h:mm a">{item.dateTime}</Moment></span>
                                            <span className="pdm-doc-size">{item.docSize}</span>
                                            {(item.docModifiedName === "esign" || evelopId) && (
                                              <span className="pdm-doc-esign-tag">
                                                <i className="fa fa-pencil-square-o" /> eSign
                                              </span>
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                      <div className="pdm-doc-actions-panel">
                                        {(isDocumentSent || evelopId) && (
                                          <span className="pdm-action-slot pdm-doc-status-stack">
                                            {(() => {
                                              const badge = getESignBadgeDetails(matchingESignDoc?.signedStatus, evelopId, isDocumentSent);
                                              if (badge) {
                                                const isPlainStatus = ["Draft", "Partially Signed"].includes(badge.text);
                                                return (
                                                  <span className={isPlainStatus ? "pdm-plain-status-text" : `pdm-badge ${badge.className}`}>
                                                    {!isPlainStatus && <i className={`fa ${badge.icon}`} />} {badge.text}
                                                  </span>
                                                );
                                              }
                                              return (
                                                <span className="pdm-badge pdm-badge-sent">
                                                  <i className="fa fa-check" /> Sent
                                                </span>
                                              );
                                            })()}
                                            {sentDate && <span className="pdm-doc-status-date"><Moment format="MMM Do YYYY">{sentDate}</Moment> | <Moment format="h:mm a">{sentDate}</Moment></span>}
                                          </span>
                                        )}
                                        {item.remarks && (
                                          <>
                                            <span className="pdm-doc-actions-divider" />
                                            <span className="pdm-action-slot">
                                              {getPopover(item.remarks, `sent_${item.docId || key}`)}
                                            </span>
                                          </>
                                        )}
                                        {hasSignedDownloadOptions ? (
                                          <span className="pdm-action-slot dropdown">
                                            <button
                                              className="pdm-btn pdm-btn-sm dropdown-toggle"
                                              type="button"
                                              id={`signedEsignDropdown-${item.docId}`}
                                              data-toggle="dropdown"
                                              aria-haspopup="true"
                                              aria-expanded="false"
                                              title="Signed Document Options"
                                            >
                                              <i className="fa fa-pencil-square-o" /> eSign
                                            </button>
                                            <div
                                              className="dropdown-menu dropdown-menu-right"
                                              aria-labelledby={`signedEsignDropdown-${item.docId}`}
                                            >
                                              {signedStatusValue !== "1" && (
                                                <button
                                                  className="dropdown-item text-left"
                                                  type="button"
                                                  onClick={() => handleViewSignedDoc(matchingESignDoc, 0)}
                                                  disabled={signLoading && selectedSignedDoc?.id === matchingESignDoc?.id}
                                                >
                                                  {signLoading && selectedSignedDoc?.id === matchingESignDoc?.id && selectedSignedDoc?.downloadType === 0 ? (
                                                    <><i className="fa fa-spinner fa-spin mr-2" /> Downloading...</>
                                                  ) : (
                                                    <><i className="fa fa-file-pdf-o mr-2" /> Visible Signed</>
                                                  )}
                                                </button>
                                              )}
                                              {signedStatusValue !== "0" && (
                                                <button
                                                  className="dropdown-item text-left"
                                                  type="button"
                                                  onClick={() => handleViewSignedDoc(matchingESignDoc, 1)}
                                                  disabled={signLoading && selectedSignedDoc?.id === matchingESignDoc?.id}
                                                >
                                                  {signLoading && selectedSignedDoc?.id === matchingESignDoc?.id && selectedSignedDoc?.downloadType === 1 ? (
                                                    <><i className="fa fa-spinner fa-spin mr-2" /> Downloading...</>
                                                  ) : (
                                                    <><i className="fa fa-certificate mr-2" /> Digital Signed</>
                                                  )}
                                                </button>
                                              )}
                                            </div>
                                          </span>
                                        ) : evelopId ? (
                                          <span className="pdm-action-slot dropdown">
                                            <button
                                              className="pdm-btn pdm-btn-sm dropdown-toggle"
                                              type="button"
                                              id={`esignDropdown-${item.docId}`}
                                              data-toggle="dropdown"
                                              aria-haspopup="true"
                                              aria-expanded="false"
                                              title="eSign Options"
                                              onClick={() => ensureDocEsignLinks(item.docId)}
                                            >
                                              <i className="fa fa-pencil-square-o" /> eSign
                                            </button>
                                            <div className="dropdown-menu dropdown-menu-right" aria-labelledby={`esignDropdown-${item.docId}`}>
                                              <a
                                                className="dropdown-item"
                                                href={prepareUrl}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                              >
                                                <i className="fa fa-pencil-square-o mr-2" /> Prepare
                                              </a>
                                              <a
                                                className="dropdown-item"
                                                href={detailsUrl}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                              >
                                                <i className="fa fa-info-circle mr-2" /> Details
                                              </a>
                                              <a
                                                className="dropdown-item"
                                                href={logsUrl}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                              >
                                                <i className="fa fa-history mr-2" /> Log
                                              </a>
                                              {currentUserCanSign && (
                                                <>
                                                  <div className="dropdown-divider" />
                                                  <button
                                                    className="dropdown-item text-left"
                                                    type="button"
                                                    onClick={() => handleOpenDocumentSignLink(item.docId)}
                                                    disabled={esignSignLinkLoadingId === item.docId}
                                                  >
                                                    {esignSignLinkLoadingId === item.docId ? (
                                                      <><i className="fa fa-spinner fa-spin mr-2" /> Opening...</>
                                                    ) : (
                                                      <><i className="fa fa-pencil-square-o mr-2" /> Sign the Document</>
                                                    )}
                                                  </button>
                                                </>
                                              )}
                                              {(esignSigned || currentUserSigned) && (
                                                <>
                                                  <div className="dropdown-divider" />
                                                  <a
                                                    className="dropdown-item"
                                                    href={visibleSignedUrl}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                  >
                                                    <i className="fa fa-file-pdf-o mr-2" /> Visible Signed
                                                  </a>
                                                  {/* The digitally signed PDF only exists once every signer has completed. */}
                                                  {esignSigned && (
                                                    <a
                                                      className="dropdown-item"
                                                      href={finalSignedUrl}
                                                      target="_blank"
                                                      rel="noopener noreferrer"
                                                    >
                                                      <i className="fa fa-certificate mr-2" /> Digital Signed
                                                    </a>
                                                  )}
                                                </>
                                              )}
                                            </div>
                                          </span>
                                        ) : (
                                          !isDocumentSent && (
                                            <>
                                              {item.docName?.toLowerCase().endsWith('.pdf') && item.docModifiedName !== "esign" ? (
                                                <span className="pdm-action-slot dropdown">
                                                  <button
                                                    className="pdm-btn pdm-btn-sm dropdown-toggle"
                                                    type="button"
                                                    id={`esignDropdown-${item.docId}`}
                                                    data-toggle="dropdown"
                                                    aria-haspopup="true"
                                                    aria-expanded="false"
                                                    title="Send Options"
                                                    disabled={loadingDocId === item.docId}
                                                  >
                                                    {loadingDocId === item.docId ? (
                                                      <><i className="fa fa-spinner fa-spin" /> Sending...</>
                                                    ) : (
                                                      <><i className="fa fa-paper-plane" /> Send</>
                                                    )}
                                                  </button>
                                                  <div className="dropdown-menu dropdown-menu-right" aria-labelledby={`esignDropdown-${item.docId}`}>
                                                    <button
                                                      className="dropdown-item text-left"
                                                      type="button"
                                                      onClick={() => handleSendDoc(item.docId)}
                                                    >
                                                      <i className="fa fa-paper-plane mr-2" /> Send
                                                    </button>
                                                    <button
                                                      className="dropdown-item text-left"
                                                      type="button"
                                                      onClick={() => handleSendThroughEsign(item)}
                                                      disabled={esignUploadLoading}
                                                    >
                                                      <i className="fa fa-pencil-square-o mr-2" /> Send to eSign
                                                    </button>
                                                  </div>
                                                </span>
                                              ) : (
                                                item.docModifiedName !== "esign" && (
                                                  <span className="pdm-action-slot">
                                                    <button
                                                      className="pdm-btn pdm-btn-sm"
                                                      onClick={() => handleSendDoc(item.docId)}
                                                      disabled={loadingDocId === item.docId}
                                                    >
                                                      {loadingDocId === item.docId ? (
                                                        <><i className="fa fa-spinner fa-spin" /> Sending...</>
                                                      ) : (
                                                        <><i className="fa fa-paper-plane" /> Send</>
                                                      )}
                                                    </button>
                                                  </span>
                                                )
                                              )}
                                            </>
                                          )
                                        )}
                                        <span className="pdm-action-slot">
                                          <button
                                            className="pdm-btn pdm-btn-sm pdm-btn-ghost-danger"
                                            onClick={() => handleDeleteDocument(item.docId)}
                                            style={{ width: '38px', padding: 0, justifyContent: 'center' }}
                                            title="Delete"
                                          >
                                            <i className="fa fa-trash" />
                                          </button>
                                        </span>
                                      </div>
                                    </div>
                                  );
                                })}
                              </div>
                            </>
                          )}

                          {/* Required documents */}
                          {(() => {
                            const uploadedReqDocs = visibleRequiredDocuments;


                            //if (uploadedReqDocs.length === 0) return null;

                            return (
                              <>
                                <div className="pdm-section-label"><i className="fa fa-tasks" /> Required Documents</div>
                                <div className="pdm-doc-list">
                                  {uploadedReqDocs.map(({ item, uploadedDocs }, key) => {
                                    // Check configuration for C2C candidates
                                    const docConfig = defaultC2CDocuments.find(doc => doc.name.toLowerCase() === item.documnetName?.toLowerCase());

                                    let uploadedDoc = uploadedDocs[0];
                                    let hasReceivedUpload = Boolean(uploadedDoc);

                                    // For generated documents, find matching document by name in appDocuments
                                    if (docConfig && docConfig.action === "generate" && !hasReceivedUpload) {
                                      const matchingGenDoc = appDocuments.find(doc =>
                                        doc.deleteFlag !== true &&
                                        doc.docName?.toLowerCase().includes(item.documnetName?.toLowerCase())
                                      );
                                      if (matchingGenDoc) {
                                        uploadedDoc = matchingGenDoc;
                                        hasReceivedUpload = true;
                                      }
                                    }

                                    const uploadedDate = uploadedDoc?.dateTime || item.addedDateTime;
                                    const refDocs = item.refDocId > 0
                                      ? appDocumentSelector.filter((x) => x.uploadId === item.refDocId && x.deleteFlag !== true)
                                      : [];

                                    return (
                                      <div key={`req-${key}`} className="pdm-doc-row pdm-doc-row-card">
                                        <div className="pdm-doc-file">
                                          <span className="pdm-doc-file-icon"><i className="fa fa-list-alt" /></span>
                                          <div className="pdm-doc-file-main">
                                            <div className="pdm-doc-title-row">
                                              {refDocs.map((refDoc) => (
                                                <span key={refDoc.docId} className="pdm-doc-name-wrapper">
                                                  <span className="pdm-doc-mini-badge">Ref</span>
                                                  <button className="pdm-doc-name" onClick={() => handleDownloadFile(refDoc)}>
                                                    {refDoc.docName}
                                                  </button>
                                                  <button
                                                    className="pdm-doc-copy-btn"
                                                    title="Copy shareable link"
                                                    onClick={(e) => {
                                                      e.stopPropagation();
                                                      handleCopyClipboard(`/DownloadDocLink/${refDoc.docId}`);
                                                    }}
                                                  >
                                                    {copyItem === `${window.location.origin}/DownloadDocLink/${refDoc.docId}` ? (
                                                      <i className="fa fa-check" style={{ color: 'var(--c-green)' }} />
                                                    ) : (
                                                      <i className="fa fa-copy" />
                                                    )}
                                                  </button>
                                                </span>
                                              ))}
                                              {refDocs.length > 0 && <span className="pdm-doc-title-separator">-</span>}
                                              <span className="pdm-doc-required-label">{item.documnetName}</span>
                                              {hasReceivedUpload && (
                                                <>
                                                  <span className="pdm-doc-title-separator">-</span>
                                                  <span className="pdm-doc-name-wrapper">
                                                    <span className="pdm-doc-mini-badge is-rec">Rec</span>
                                                    <button className="pdm-doc-name" onClick={() => handleDownloadFile(uploadedDoc)}>
                                                      {uploadedDoc.docName}
                                                    </button>
                                                    <button
                                                      className="pdm-doc-copy-btn"
                                                      title="Copy shareable link"
                                                      onClick={(e) => {
                                                        e.stopPropagation();
                                                        handleCopyClipboard(`/DownloadDocLink/${uploadedDoc.docId}`);
                                                      }}
                                                    >
                                                      {copyItem === `${window.location.origin}/DownloadDocLink/${uploadedDoc.docId}` ? (
                                                        <i className="fa fa-check" style={{ color: 'var(--c-green)' }} />
                                                      ) : (
                                                        <i className="fa fa-copy" />
                                                      )}
                                                    </button>
                                                  </span>
                                                </>
                                              )}                                          </div>
                                            <div className="pdm-doc-meta">
                                              <span className="pdm-doc-date"><Moment format="MMM Do YYYY">{uploadedDate}</Moment> | <Moment format="h:mm a">{uploadedDate}</Moment></span>
                                              {uploadedDoc?.docSize ? <span className="pdm-doc-size">{uploadedDoc.docSize}</span> : null}
                                            </div>
                                          </div>
                                        </div>
                                        <div className="pdm-doc-actions-panel">
                                          <span className="pdm-action-slot" style={{ display: 'inline-flex', alignItems: 'center', gap: '8px' }}>
                                            {hasReceivedUpload ? (
                                              <span className="pdm-badge pdm-badge-done"><i className="fa fa-check" /> Done</span>
                                            ) : (
                                              <>
                                                <span className="pdm-not-received-text">Not Received</span>
                                                {item.sendStatus === true ? (
                                                  <span className="pdm-badge pdm-badge-sent">
                                                    <i className="fa fa-check" /> Sent
                                                  </span>
                                                ) : (
                                                  <button
                                                    type="button"
                                                    className="pdm-btn pdm-btn-sm"
                                                    onClick={() => handleSendReqDocument(getRequiredDocumentId(item))}
                                                    disabled={loadingDocId === getRequiredDocumentId(item)}
                                                  >
                                                    {loadingDocId === getRequiredDocumentId(item) ? (
                                                      <><i className="fa fa-spinner fa-spin" /> Sending...</>
                                                    ) : (
                                                      <><i className="fa fa-paper-plane" /> Send</>
                                                    )}
                                                  </button>
                                                )}
                                                {docConfig && docConfig.action === "generate" ? (
                                                  docConfig.ddrmsDocId && docConfig.mappingId ? (
                                                    <button
                                                      type="button"
                                                      className="pdm-btn pdm-btn-sm pdm-btn-primary"
                                                      onClick={() => handleContractShowHide("contract", item, docConfig)}
                                                      disabled={!item.sendStatus}
                                                    >
                                                      <i className="fa fa-magic" /> Generate
                                                    </button>
                                                  ) : null
                                                ) : (
                                                  <button
                                                    type="button"
                                                    className="pdm-btn pdm-btn-sm pdm-btn-secondary"
                                                    onClick={() => handleDocShowHide("upload", `req_${!item.id ? item.docId : item.id}`)}
                                                    disabled={item.sendStatus !== true}
                                                  >
                                                    <i className="fa fa-upload" /> Upload
                                                  </button>
                                                )}
                                              </>
                                            )}
                                          </span>
                                          {(uploadedDoc?.remarks || item.notes) ? (
                                            <span className="pdm-action-slot">
                                              {getPopover(uploadedDoc?.remarks || item.notes, `req_${item.id || key}`)}
                                            </span>
                                          ) : null}

                                          {hasReceivedUpload && (
                                            <>
                                              <span className="pdm-doc-actions-divider" />
                                              {docConfig && docConfig.action === "generate" ? (
                                                <>
                                                  {uploadedDoc.sendStatus ? (
                                                    <span className="pdm-action-slot pdm-doc-status-stack">
                                                      <span className="pdm-badge pdm-badge-sent"><i className="fa fa-check" /> Sent</span>
                                                      {uploadedDoc.sentDateTime && <span className="pdm-doc-status-date"><Moment format="MMM Do YYYY">{uploadedDoc.sentDateTime}</Moment> | <Moment format="h:mm a">{uploadedDoc.sentDateTime}</Moment></span>}
                                                    </span>
                                                  ) : (
                                                    <span className="pdm-action-slot">
                                                      <button
                                                        className="pdm-btn pdm-btn-sm"
                                                        onClick={() => handleSendDoc(uploadedDoc.docId)}
                                                        disabled={loadingDocId === uploadedDoc.docId}
                                                      >
                                                        {loadingDocId === uploadedDoc.docId ? (
                                                          <><i className="fa fa-spinner fa-spin" /> Sending...</>
                                                        ) : (
                                                          <><i className="fa fa-paper-plane" /> Send</>
                                                        )}
                                                      </button>
                                                    </span>
                                                  )}
                                                  <span className="pdm-action-slot">
                                                    <button
                                                      className="pdm-btn pdm-btn-sm pdm-btn-ghost-danger"
                                                      onClick={() => handleDeleteDocument(uploadedDoc.docId)}
                                                      style={{ width: '38px', padding: 0, justifyContent: 'center' }}
                                                      title="Delete"
                                                    >
                                                      <i className="fa fa-trash" />
                                                    </button>
                                                  </span>
                                                </>
                                              ) : (
                                                <>
                                                  {uploadedDoc.sendStatus || item.sendStatus ? (
                                                    <span className="pdm-action-slot pdm-doc-status-stack">
                                                      <span className="pdm-badge pdm-badge-sent"><i className="fa fa-check" /> Sent</span>
                                                      {(uploadedDoc.sentDateTime || item.sentDateTime) && (
                                                        <span className="pdm-doc-status-date">
                                                          <Moment format="MMM Do YYYY">{uploadedDoc.sentDateTime || item.sentDateTime}</Moment> | <Moment format="h:mm a">{uploadedDoc.sentDateTime || item.sentDateTime}</Moment>
                                                        </span>
                                                      )}
                                                    </span>
                                                  ) : (
                                                    <span className="pdm-action-slot">
                                                      <button
                                                        className="pdm-btn pdm-btn-sm"
                                                        onClick={() => handleSendReqDocument(item.id)}
                                                        disabled={loadingDocId === item.id}
                                                      >
                                                        {loadingDocId === item.id ? (
                                                          <><i className="fa fa-spinner fa-spin" /> Sending...</>
                                                        ) : (
                                                          <><i className="fa fa-paper-plane" /> Send</>
                                                        )}
                                                      </button>
                                                    </span>
                                                  )}
                                                  <span className="pdm-action-slot">
                                                    <button
                                                      className="pdm-btn pdm-btn-sm pdm-btn-ghost-danger"
                                                      onClick={() => handleDeleteDocument(uploadedDoc.docId)}
                                                      style={{ width: '38px', padding: 0, justifyContent: 'center' }}
                                                      title="Delete uploaded file"
                                                    >
                                                      <i className="fa fa-trash" />
                                                    </button>
                                                  </span>
                                                </>
                                              )}
                                            </>
                                          )}

                                          {/* Once a file is received the row already shows a delete for
                                            that file; removing the requirement itself is only offered
                                            while nothing is attached to it. */}
                                          {!hasReceivedUpload && (
                                            <>
                                              <span className="pdm-doc-actions-divider" />
                                              <span className="pdm-action-slot">
                                                <button
                                                  className="pdm-btn pdm-btn-sm pdm-btn-ghost-danger"
                                                  onClick={() => handleDeleteReqDocument(getRequiredDocumentId(item))}
                                                  style={{ width: '38px', padding: 0, justifyContent: 'center' }}
                                                  title="Remove this required document"
                                                >
                                                  <i className="fa fa-trash" />
                                                </button>
                                              </span>
                                            </>
                                          )}
                                        </div>
                                      </div>
                                    );
                                  })}
                                </div>
                              </>
                            );
                          })()}

                          {/* Pending default documents checklist below uploaded documents */}
                          {pendingDefaultDocuments.length > 0 && currentFlowType && (
                            <div className="pdm-default-docs-embedded" style={{ marginTop: 24 }}>
                              <div className="pdm-section-label" style={{ marginBottom: 12 }}>
                                <i className="fa fa-clock-o" /> Pending Default Documents ({pendingDefaultDocuments.length})
                              </div>
                              {renderDefaultDocuments(true, pendingDefaultDocuments, "Pending Default Documents")}
                            </div>
                          )}
                        </>
                      )}
                    </>
                  )}
                </div>
              </CustomTab>

              {/* ——— RECEIVED tab ——— */}
              {uploadType !== "agency" && uploadType !== "msp" && (pageModule === "review" || pageModule === "review1") && (
                <CustomTab
                  eventKey={4}
                  title={
                    <span>
                      <i className="fa fa-inbox mr-1" /> Received
                      <span className="tab-count ml-2">{receviedDocumnets.length}</span>
                    </span>
                  }
                >
                  <div className="pdm-tab-body">
                    {receviedDocumnets.length === 0 ? (
                      <div className="pdm-empty">
                        <div className="pdm-empty-icon"><i className="fa fa-inbox" /></div>
                        <h5>No received documents</h5>
                        <p>Documents sent to you will appear here.</p>
                      </div>
                    ) : (
                      <div className="pdm-doc-list">
                        {receviedDocumnets.map((item, key) => (
                          <div key={key} className="pdm-doc-row" style={{ gridTemplateColumns: '28px 1fr auto auto auto' }}>
                            <div className="pdm-col-center" style={{ color: '#64748b', fontSize: '12px', fontWeight: 600 }}>{key + 1}</div>
                            <div className="pdm-doc-info">
                              <span className="pdm-doc-name-wrapper">
                                <button className="pdm-doc-name" onClick={() => handleDownloadFile(item)}>
                                  <i className={`fa ${getDocumentIcon(item)}`} /> {item.docName}
                                </button>
                                <button
                                  className="pdm-doc-copy-btn"
                                  title="Copy shareable link"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleCopyClipboard(`/DownloadDocLink/${item.docId}`);
                                  }}
                                >
                                  {copyItem === `${window.location.origin}/DownloadDocLink/${item.docId}` ? (
                                    <i className="fa fa-check" style={{ color: 'var(--c-green)' }} />
                                  ) : (
                                    <i className="fa fa-copy" />
                                  )}
                                </button>
                              </span>
                              <div className="pdm-doc-meta">
                                <span className="pdm-doc-date"><Moment format="MMM Do YYYY, h:mm a">{item.dateTime}</Moment></span>
                                {item.remarks && <span className="pdm-doc-type-tag">{item.remarks}</span>}
                              </div>
                            </div>
                            <div className="pdm-col-center">
                              {getPopover(item.remarks, `received_${item.docId || key}`)}
                            </div>
                            <div className="pdm-col-center">
                              <button
                                className="pdm-btn pdm-btn-sm pdm-btn-ghost-danger"
                                onClick={() => handleDeleteDocument(item.docId)}
                                style={{ width: '38px', padding: 0, justifyContent: 'center' }}
                                title="Delete"
                              >
                                <i className="fa fa-trash" />
                              </button>
                            </div>
                            <div className="pdm-col-center">
                              <select
                                className="pdm-select"
                                value={item.docStatus}
                                onChange={(e) => handleDocStatusChange(item.docId, e.target.value)}
                              >
                                <option value="">Set Status</option>
                                <option value="1">✓ Approved</option>
                                <option value="0">✗ Not Approved</option>
                              </select>
                            </div>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </CustomTab>
              )}

              {/* ——— INTERNAL tab ——— */}
              {uploadType !== "agency" && uploadType !== "msp" &&
                (uploadType !== "Subcontractor" || viewType === "subList") && (
                  <CustomTab
                    eventKey={5}
                    title={
                      <span>
                        <i className="fa fa-lock mr-1" /> Internal
                        <span className="tab-count ml-2">
                          {sentDocuments.filter(x => x.uploadType !== "client" && x.uploadType !== "reporting" && x.uploadType !== "project" && x.updType === "internal").length}
                        </span>
                      </span>
                    }
                  >
                    <div className="pdm-tab-body">

                      {(() => {
                        const internalDocs = sentDocuments.filter(x => x.uploadType !== "client" && x.uploadType !== "reporting" && x.uploadType !== "project" && x.updType === "internal");
                        if (internalDocs.length === 0) return (
                          <div className="pdm-empty">
                            <div className="pdm-empty-icon"><i className="fa fa-lock" /></div>
                            <h5>No internal documents</h5>
                            <p>Internal documents uploaded here are not shared externally.</p>
                          </div>
                        );
                        return (
                          <div className="pdm-doc-list">
                            {internalDocs.map((item, key) => (
                              <div key={key} className="pdm-doc-row pdm-doc-row-card">
                                <div className="pdm-doc-file">
                                  <span className="pdm-doc-file-icon"><i className={`fa ${getDocumentIcon(item)}`} /></span>
                                  <div className="pdm-doc-file-main">
                                    <span className="pdm-doc-name-wrapper">
                                      <button className="pdm-doc-name" onClick={() => handleDownloadFile(item)}>
                                        {item.docId} - {item.docName}
                                      </button>
                                      <button
                                        className="pdm-doc-copy-btn"
                                        title="Copy shareable link"
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          handleCopyClipboard(`/DownloadDocLink/${item.docId}`);
                                        }}
                                      >
                                        {copyItem === `${window.location.origin}/DownloadDocLink/${item.docId}` ? (
                                          <i className="fa fa-check" style={{ color: 'var(--c-green)' }} />
                                        ) : (
                                          <i className="fa fa-copy" />
                                        )}
                                      </button>
                                    </span>
                                    <div className="pdm-doc-meta">
                                      <span className="pdm-doc-date"><Moment format="MMM Do YYYY">{item.dateTime}</Moment> | <Moment format="h:mm a">{item.dateTime}</Moment></span>
                                      {item.docSize ? <span className="pdm-doc-size">{item.docSize}</span> : null}
                                    </div>
                                  </div>
                                </div>
                                <div className="pdm-doc-actions-panel">
                                  <span className="pdm-action-slot">
                                    {getPopover(item.remarks, `internal_${item.docId || key}`)}
                                  </span>
                                  <span className="pdm-doc-actions-divider" />
                                  <span className="pdm-action-slot">
                                    <button
                                      className="pdm-btn pdm-btn-sm pdm-btn-ghost-danger"
                                      onClick={() => handleDeleteDocument(item.docId)}
                                      style={{ width: '38px', padding: 0, justifyContent: 'center' }}
                                      title="Delete"
                                    >
                                      <i className="fa fa-trash" />
                                    </button>
                                  </span>
                                </div>
                              </div>
                            ))}
                          </div>
                        );
                      })()}
                    </div>
                  </CustomTab>
                )}

              {/* DELETED tab */}
              <CustomTab
                eventKey={3}
                title={
                  <span>
                    <i className="fa fa-trash mr-1" /> Deleted
                    <span className="tab-count ml-2">
                      {(uploadType === "agency" || uploadType === "msp") ? deletedAgencyMspDocumnets.length : deletedDocumnets.filter(x => x.uploadType !== "msp" && x.uploadType !== "agency").length}
                    </span>
                  </span>
                }
              >
                <div className="pdm-tab-body">
                  {(() => {
                    const docs = (uploadType === "agency" || uploadType === "msp")
                      ? deletedAgencyMspDocumnets
                      : deletedDocumnets.filter(x => x.uploadType !== "msp" && x.uploadType !== "agency");
                    if (docs.length === 0) return (
                      <div className="pdm-empty">
                        <div className="pdm-empty-icon"><i className="fa fa-trash-o" /></div>
                        <h5>Trash is empty</h5>
                        <p>Deleted documents will appear here for recovery.</p>
                      </div>
                    );
                    return (
                      <div className="pdm-doc-list">
                        {docs.map((item, key) => (
                          <div key={key} className="pdm-doc-row pdm-doc-row-card">
                            <div className="pdm-doc-file">
                              <span className="pdm-doc-file-icon"><i className={`fa ${getDocumentIcon(item)}`} /></span>
                              <div className="pdm-doc-file-main">
                                <span className="pdm-doc-name-wrapper">
                                  <button className="pdm-doc-name" style={{ color: 'var(--c-text-2)' }} onClick={() => handleDownloadFile(item)}>
                                    {item.docId} - {item.docName}
                                  </button>
                                  <button
                                    className="pdm-doc-copy-btn"
                                    title="Copy shareable link"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      handleCopyClipboard(`/DownloadDocLink/${item.docId}`);
                                    }}
                                  >
                                    {copyItem === `${window.location.origin}/DownloadDocLink/${item.docId}` ? (
                                      <i className="fa fa-check" style={{ color: 'var(--c-green)' }} />
                                    ) : (
                                      <i className="fa fa-copy" />
                                    )}
                                  </button>
                                </span>
                                <div className="pdm-doc-meta">
                                  <span className="pdm-doc-date"><Moment format="MMM Do YYYY">{item.dateTime}</Moment> | <Moment format="h:mm a">{item.dateTime}</Moment></span>
                                  {item.docSize ? <span className="pdm-doc-size">{item.docSize}</span> : null}
                                  {item.uploaderName && <span className="pdm-doc-uploader">{item.uploaderName}</span>}
                                </div>
                              </div>
                            </div>
                            <div className="pdm-doc-actions-panel">
                              {uploadType !== "agency" && uploadType !== "msp" && (
                                <span className="pdm-action-slot">
                                  {getPopover(item.remarks, `deleted_${item.docId || key}`)}
                                </span>
                              )}
                              <span className="pdm-doc-actions-divider" />
                              <span className="pdm-action-slot">
                                <button className="pdm-btn pdm-btn-sm pdm-btn-ghost-indigo" onClick={() => handleRollbackDocument(item.docId)}>
                                  <i className="fa fa-undo" /> Restore
                                </button>
                              </span>
                              <span className="pdm-action-slot">
                                <button className="pdm-btn pdm-btn-sm pdm-btn-ghost-danger" onClick={() => handlePurgeDocument(item.docId)}>
                                  <i className="fa fa-times-circle" /> Purge
                                </button>
                              </span>
                            </div>
                          </div>
                        ))}
                      </div>
                    );
                  })()}
                </div>
              </CustomTab>

              {/* HISTORY tab */}
              <CustomTab
                eventKey={6}
                title={<span><i className="fa fa-history mr-1" /> History</span>}
              >
                <div className="pdm-tab-body">
                  <div className="pdm-history-grid">
                    {uploadType !== "agency" && uploadType !== "msp" && (
                      <div className="pdm-history-card">
                        <div className="pdm-history-card-head">
                          Received
                        </div>
                        <div className="pdm-history-card-body">
                          {receviedDocumnets.filter(x => x.uploaderId === applicantObj?.id || x.uploaderId === applicantObj?.subcontractor?.parentid || x.uploaderId === applicantObj?.recruiter?.parentid).length === 0
                            ? <p style={{ color: '#64748b', fontSize: '14px', fontWeight: 400, margin: 0 }}>No records</p>
                            : receviedDocumnets.filter(x => x.uploaderId === applicantObj?.id || x.uploaderId === applicantObj?.subcontractor?.parentid || x.uploaderId === applicantObj?.recruiter?.parentid).map((doc, i) => (
                              <div key={i} className="pdm-history-doc-item">
                                <div>
                                  <button className="pdm-history-doc-name" onClick={() => handleDownloadFile(doc)}>{doc.docName}</button>
                                  <div className="pdm-history-doc-date"><Moment format="MMM Do YYYY">{doc.dateTime}</Moment></div>
                                </div>
                              </div>
                            ))
                          }
                        </div>
                      </div>
                    )}

                    <div className="pdm-history-card">
                      <div className="pdm-history-card-head">
                        Sent
                      </div>
                      <div className="pdm-history-card-body">
                        {sentDocuments.filter(x => x.uploadType !== "client" && x.uploadType !== "reporting" && x.uploadType !== "project" && x.uploadType !== "agency" && x.uploadType !== "msp" && x.updType !== "internal" && x.sentStatus === true).length === 0
                          ? <p style={{ color: '#64748b', fontSize: '14px', fontWeight: 400, margin: 0 }}>No records</p>
                          : sentDocuments.filter(x => x.uploadType !== "client" && x.uploadType !== "reporting" && x.uploadType !== "project" && x.uploadType !== "agency" && x.uploadType !== "msp" && x.updType !== "internal" && x.sentStatus === true).map((doc, i) => (
                            <div key={i} className="pdm-history-doc-item">
                              <div>
                                <button className="pdm-history-doc-name" onClick={() => handleDownloadFile(doc)}>{doc.docName}</button>
                                <div className="pdm-history-doc-date"><Moment format="MMM Do YYYY">{doc.dateTime}</Moment></div>
                              </div>
                            </div>
                          ))
                        }
                      </div>
                    </div>

                    {uploadType !== "agency" && uploadType !== "msp" && (
                      <div className="pdm-history-card">
                        <div className="pdm-history-card-head">
                          Internal
                        </div>
                        <div className="pdm-history-card-body">
                          {sentDocuments.filter(x => x.updType === "internal" && x.uploadType !== "reporting" && x.uploadType !== "project").length === 0
                            ? <p style={{ color: '#64748b', fontSize: '14px', fontWeight: 400, margin: 0 }}>No records</p>
                            : sentDocuments.filter(x => x.updType === "internal" && x.uploadType !== "reporting" && x.uploadType !== "project").map((doc, i) => (
                              <div key={i} className="pdm-history-doc-item">
                                <div>
                                  <button className="pdm-history-doc-name" onClick={() => handleDownloadFile(doc)}>{doc.docName}</button>
                                  <div className="pdm-history-doc-date"><Moment format="MMM Do YYYY">{doc.dateTime}</Moment></div>
                                </div>
                              </div>
                            ))
                          }
                        </div>
                      </div>
                    )}

                    {uploadType !== "Subcontractor" && uploadType !== "Recruiter" && (
                      <div className="pdm-history-card">
                        <div className="pdm-history-card-head">
                          Agency / Client
                        </div>
                        <div className="pdm-history-card-body">
                          {clientDocs.length === 0
                            ? <p style={{ color: '#64748b', fontSize: '14px', fontWeight: 400, margin: 0 }}>No records</p>
                            : clientDocs.map((doc, i) => (
                              <div key={i} className="pdm-history-doc-item">
                                <div>
                                  <button className="pdm-history-doc-name" onClick={() => handleDownloadFile(doc)}>{doc.docName}</button>
                                  <div className="pdm-history-doc-date"><Moment format="MMM Do YYYY">{doc.dateTime}</Moment></div>
                                </div>
                              </div>
                            ))
                          }
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </CustomTab>

              {/* PURCHASE ORDER tab */}
              {viewType === "candidateList" && (
                <CustomTab
                  eventKey={7}
                  title={<span><i className="fa fa-shopping-cart mr-1" /> Purchase Order</span>}
                >
                  <div className="pdm-tab-body">
                    <PurchaseOrderPopup
                      purchaseShowHide={true}
                      hideHeader
                      handlePurchaseShowHide={handlePurchaseShowHide}
                      candidateObj={applicantObj}
                      workflowTask={wfTask}
                      poOrderType={"add"}
                      item={{ partnerType: uploadType === "Recruiter" ? "Recruiter" : "Sub-Contractors" }}
                      handleSignUnsignPo={handleSignUnsignPo}
                      handleRefreshPoOrders={handleRefreshPoOrders}
                      renderType="generate"
                    />
                  </div>
                </CustomTab>
              )}
            </CustomTabs>
          </div>
        )}

        {/* bottom padding */}
        <div style={{ height: 8 }} />
      </div>

      {docShowHide && (
        <CandidateReqDoc
          docShowHide={docShowHide}
          handleDocShowHide={handleDocShowHide}
          workItem={((uploadType === "Subcontractor" || uploadType === "Recruiter" || uploadType === "agency" || uploadType === "msp")
            && viewType !== "candidateList") || (uploadType === "Candidate" && viewType === "candidateList") ? wfTask : partnerCurrentWfTask}
          sendType={sendType}
          uploadType={uploadType}
          applicantObj={applicantObj}
          viewType={viewType}
          uploadDocType={uploadDocType}
          prevItem={prevItem}
        />
      )}

      {showHide && (
        <InternalReviewPopup
          showHide={showHide}
          handleModalShowHide={handleModalShowHide}
          handleSubmit={handleSubmit}
          selectedItem={selectedObj}
          handleEditComment={handleEditComment}
          viewType={viewType}
        />
      )}

      {otherDocShowHide && (
        <UploadOther
          handleOtherDocShowHide={handleOtherDocShowHide}
          otherDocShowHide={otherDocShowHide}
          workflowTask={((uploadType === "Subcontractor" || uploadType === "Recruiter" || uploadType === "agency" ||
            uploadType === "msp") && viewType !== "candidateList") || (uploadType === "Candidate" && viewType === "candidateList") ? wfTask : partnerCurrentWfTask}
          onReqDocs={onReqDocs}
          uploadType={uploadType}
          uploadDocType={uploadDocType}
          viewType={viewType}
          applicantObj={applicantObj}
          prevItem={prevItem}
        />
      )}

      {contractShowHide && (
        <GenerateContract
          showHide={contractShowHide}
          uploadType={uploadType}
          handleModalShowHide={handleContractShowHide}
          workflowTask={((uploadType === "Subcontractor" || uploadType === "Recruiter" || uploadType === "agency" || uploadType === "msp") && viewType !== "candidateList") || (uploadType === "Candidate" && viewType === "candidateList") ? wfTask : partnerCurrentWfTask}
          app={app}
          applicantObj={applicantObj}
          prevItem={prevItem}
          viewType={viewType}
          ddrmsDocId={selectedReqDocMapping ? selectedReqDocMapping.ddrmsDocId : null}
          defaultMappingId={selectedReqDocMapping ? selectedReqDocMapping.mappingId : null}
        />
      )}

      {showDefaultDocsModal && renderDefaultDocuments(false)}
    </React.Fragment>
  );
};

export default Document;

